<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2 dq-page-actions"
        >
          <div>
            <!-- <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    ><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    ><i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div> -->
          </div>

          

          <div v-if="!isSuperAdmin">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              @click.prevent="openAddModal"
              v-can="'EmployeeSalary.Create'"
              ><i class="ti ti-circle-plus me-2"></i>Add Salary</a
            >
          </div>

          <div v-if="!isSuperAdmin">
            <button
              type="button"
              class="btn d-flex align-items-center"
              :class="hasSalaryRows ? 'btn-success' : 'btn-secondary'"
              :disabled="!hasSalaryRows"
              :title="
                hasSalaryRows
                  ? 'Generate payroll for employees with salary setup'
                  : 'Add employee salary records first before generating payroll'
              "
              data-bs-toggle="modal"
              data-bs-target="#generate-payroll-modal"
              @click="hasSalaryRows && openGeneratePayrollModal()"
            >
              <i class="ti ti-calculator me-2"></i>Generate Payroll
            </button>
            <!-- <div v-if="!hasSalaryRows" class="small text-muted mt-1">
              Add at least one employee salary record first.
            </div> -->
          </div>
          <div
            v-if="!isSuperAdmin && hasReviewablePayroll && canApprovePayrollRole"
          >
            <a
              href="javascript:void(0);"
              class="btn btn-outline-primary d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#generate-payroll-modal"
              @click="openReviewPayrollModal"
            >
              <i class="ti ti-eye me-2"></i>Review Payroll
            </a>
          </div>
          <div v-if="!isSuperAdmin">
            <router-link
              :to="listPeriodBankTransferLink"
              class="btn btn-outline-secondary d-flex align-items-center"
            >
              <i class="ti ti-building-bank me-2"></i>Bank transfer file
            </router-link>
          </div>
          <div class="head-icons">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div class="card">
        <div
          class="card-header d-flex align-items-end justify-content-between flex-wrap gap-3"
        >
          <div class="me-auto">
            <h5 class="mb-1">Employee Salary List</h5>
            <div class="text-muted fs-13">
              One row per employee for the selected payroll month.
            </div>
          </div>
          <div class="d-flex align-items-end flex-wrap gap-3">
            <div style="min-width: 240px; max-width: 300px; flex: 1 1 240px">
              <label class="form-label text-muted small mb-1" for="employee-salary-list-search">
                Search
              </label>
              <div class="input-icon-start position-relative">
                <span class="input-icon-addon">
                  <i class="ti ti-search"></i>
                </span>
                <input
                  id="employee-salary-list-search"
                  v-model.trim="listSearch"
                  type="search"
                  class="form-control"
                  placeholder="Name, Emp ID, email…"
                />
              </div>
            </div>
            <div style="min-width: 180px; max-width: 220px">
              <label class="form-label text-muted small mb-1" for="employee-salary-list-period">
                Payroll month
              </label>
              <input
                id="employee-salary-list-period"
                v-model="listPeriod"
                type="month"
                class="form-control"
                :disabled="employeeSalaryStore.loading"
              />
            </div>
          </div>
          <!-- <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon">
                  <i class="ti ti-chevron-down"></i>
                </span>
              </div>
            </div>
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Designation
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Finance</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Developer</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Executive</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Manager</a
                  >
                </li>
              </ul>
            </div>
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Recently Added</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Ascending</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Desending</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Last Month</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    >Last 7 Days</a
                  >
                </li>
              </ul>
            </div>
          </div> -->
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="filteredTableData"
              :loading="employeeSalaryStore.loading"
              :row-selection="rowSelection"
              :customRow="onRow"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Name'">
                  <div class="d-flex align-items-center file-name-icon">
                    <a href="javascript:void(0);">
                      <DqAvatar
                        :src="record.Image"
                        :name="record.Name"
                        size-class="avatar-md"
                        shape-class="rounded-circle"
                      />
                    </a>
                    <div class="ms-2">
                      <h6 class="fw-medium">
                        <a href="javascript:void(0);">{{ record.Name }}</a>
                      </h6>
                      <span class="d-block mt-1">{{ record.Work }}</span>
                    </div>
                  </div>
                </template>
                <template v-if="column.key === 'Designation'">
                  <div>{{ record.Designation }}</div>
                </template>

                <template v-if="column.key === 'Payslip'">
                  <div v-if="!isSuperAdmin">
                    <span
                      class="badge badge-md"
                      :class="payslipBadgeClass(record)"
                      :style="{
                        cursor: isGeneratingPayslip(record._raw)
                          ? 'not-allowed'
                          : record.canGenerateSlip || record.canPreviewSlip
                            ? 'pointer'
                            : 'default',
                        opacity: isGeneratingPayslip(record._raw) ? 0.7 : 1,
                      }"
                      @click.stop.prevent="
                        !isGeneratingPayslip(record._raw) &&
                          (record.canGenerateSlip
                            ? handlePayslipAction(record._raw)
                            : record.canPreviewSlip &&
                              previewPayslipFromSalaryRow(record))
                      "
                    >
                      <template v-if="isGeneratingPayslip(record._raw)">
                        <span
                          class="spinner-border spinner-border-sm me-1"
                        ></span>
                        Generating...
                      </template>
                      <template v-else>
                        {{ record.Payslip }}
                      </template>
                    </span>
                    <div
                      v-if="record.payrollRunStatus && record.payrollRunStatus !== 'completed'"
                      class="small text-muted mt-1"
                    >
                      Payroll status: {{ record.payrollRunStatus }}
                    </div>
                    <div
                      v-else-if="record.payslipPeriodLabel"
                      class="small text-muted mt-1"
                    >
                      {{ record.payslipPeriodLabel }}
                    </div>
                  </div>
                </template>

                <template v-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <!-- View salary (everyone can view) -->
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      @click.stop.prevent="openViewSalary(record)"
                      v-can="'EmployeeSalary.Read'"
                    >
                      <i class="ti ti-eye"></i>
                    </a>

                    <!-- Edit / Delete only for non-SuperAdmin -->
                    <template v-if="!isSuperAdmin">
                      <a
                        href="javascript:void(0);"
                        class="me-2"
                        @click.stop.prevent="openEditModal(record)"
                        v-can="'EmployeeSalary.Edit'"
                      >
                        <i class="ti ti-edit"></i>
                      </a>
                      <a
                        href="javascript:void(0);"
                        @click.stop.prevent="openDeleteModal(record)"
                        v-can="'EmployeeSalary.Delete'"
                      >
                        <i class="ti ti-trash"></i>
                      </a>
                    </template>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <EmployeeSalaryModal
    ref="employeeSalaryModalRef"
    :employeeToDelete="toDeleteEmployee"
    :employeeSalary="modalSalaryEmployee"
    @refresh="fetchSalaries"
  />

  <!-- 👁 View Salary Details Modal (Upgraded UI) -->
  <div
    class="modal fade dq-modal"
    id="view-employee-salary"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content dq-modal-content">
        <!-- Header -->
        <div class="dq-modal-header">
          <div class="dq-header-left">
            <div class="dq-modal-icon">
              <!-- <i class="ti ti-currency-dollar"></i> -->
              <span style="font-size: 12px"> {{ companyCurrencySymbol }}</span>
            </div>
            <div class="dq-header-titles">
              <h4 class="dq-title" style="color: white">Salary Details</h4>
              <div class="dq-subtitle" v-if="viewSalary">
                {{ viewSalary.employee?.first_name }}
                {{ viewSalary.employee?.last_name }}
                <span class="dq-dot">•</span>
                {{ viewSalary.employee?.employee_id || "-" }}
                <span class="dq-dot">•</span>
                {{ formatPayrollMonth(viewSalaryEffectivePeriod) }}
              </div>
              <div class="dq-subtitle" v-else>No salary selected</div>
              <div
                v-if="viewSalary && viewSalaryPeriodMismatch"
                class="dq-subtitle text-warning-emphasis small mt-1"
              >
                Salary record:
                {{ formatPayrollMonth(viewSalary.payroll_month) }}
                • Payslip:
                {{ formatPayrollMonth(viewSalary.payroll_run_period) }}
              </div>
            </div>
          </div>

          <div class="dq-header-right">
            <div v-if="viewSalary" class="dq-pill">
              <i class="ti ti-calendar-month"></i>
              <span>{{ formatPayrollMonth(viewSalaryEffectivePeriod) }}</span>
            </div>

            <button
              type="button"
              class="btn btn-icon btn-light dq-close"
              aria-label="Close"
              @click="closeViewSalary"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>

        <!-- Body -->
        <div class="dq-modal-body dq-scroll">
          <div v-if="viewSalary" class="row g-4">
            <!-- Left: Employee Card + Net Pay -->
            <div class="col-lg-4">
              <div class="dq-card dq-card-gradient">
                <div class="dq-employee">
                  <div class="dq-avatar">
                    <DqAvatar
                      :src="viewSalary.employee?.avatar_url || ''"
                      :name="`${viewSalary.employee?.first_name || ''} ${viewSalary.employee?.last_name || ''}`.trim()"
                      size-class="avatar-xl"
                      shape-class="rounded-circle"
                    />
                  </div>
                  <div class="dq-emp-meta">
                    <div class="dq-emp-name">
                      {{ viewSalary.employee?.first_name }}
                      {{ viewSalary.employee?.last_name }}
                    </div>
                    <div class="dq-emp-sub">
                      <span class="dq-chip">
                        <i class="ti ti-id"></i>
                        {{ viewSalary.employee?.employee_id || "-" }}
                      </span>
                      <span
                        class="dq-chip"
                        v-if="viewSalary.employee?.designation?.name"
                      >
                        <i class="ti ti-briefcase"></i>
                        {{ viewSalary.employee?.designation?.name }}
                      </span>
                      <span
                        class="dq-chip"
                        v-if="viewSalary.employee?.department?.name"
                      >
                        <i class="ti ti-building"></i>
                        {{ viewSalary.employee?.department?.name }}
                      </span>
                      <span
                        class="dq-chip"
                        v-if="viewSalary.employee?.employment_type"
                      >
                        <i class="ti ti-user-check"></i>
                        {{ viewSalary.employee?.employment_type }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="dq-divider"></div>

                <div class="dq-metric">
                  <div class="dq-metric-label">Net Pay</div>
                  <div class="dq-metric-value">
                    {{ money(viewSalarySummaryTotals.net_pay) }}
                  </div>
                  <div class="dq-metric-hint">
                    After all statutory + voluntary deductions
                  </div>
                </div>

                <div class="dq-actions mt-3" v-if="!isSuperAdmin">
                  <button
                    type="button"
                    class="btn w-100 dq-btn"
                    :class="canUseViewSalaryPayslipAction ? 'btn-primary' : 'btn-secondary'"
                    :disabled="!canUseViewSalaryPayslipAction"
                    @click.prevent="downloadPayslipForViewSalary"
                  >
                    <i
                      class="me-2"
                      :class="viewSalary?.payroll_result?.payslip?.id ? 'ti ti-download' : 'ti ti-receipt'"
                    ></i>
                    {{ viewSalaryPayslipLabel }}
                  </button>
                  <div class="dq-muted mt-2" v-if="!canUseViewSalaryPayslipAction">
                    Complete and approve payroll for this employee and month first.
                  </div>
                </div>
              </div>

              <div class="dq-card mt-3">
                <div class="dq-mini-grid">
                  <div class="dq-mini">
                    <div class="dq-mini-label">Taxable Income</div>
                    <div class="dq-mini-value">
                      {{ money(viewSalarySummaryTotals.taxable_income) }}
                    </div>
                  </div>
                  <div class="dq-mini">
                    <div class="dq-mini-label">Total Deductions</div>
                    <div class="dq-mini-value">
                      {{ money(viewSalarySummaryTotals.total_deductions) }}
                    </div>
                  </div>
                  <div class="dq-mini">
                    <div class="dq-mini-label">Gross Salary</div>
                    <div class="dq-mini-value">
                      {{ money(viewSalarySummaryTotals.gross_salary) }}
                    </div>
                  </div>
                </div>

                <div class="dq-muted mt-2">
                  Created:
                  {{
                    viewSalary.created_at
                      ? formatDate(viewSalary.created_at)
                      : "-"
                  }}
                </div>
              </div>
            </div>

            <!-- Right: Breakdown -->
            <div class="col-lg-8">
              <div class="dq-card">
                <div class="dq-card-header">
                  <div class="dq-card-title">
                    <i class="ti ti-receipt"></i> Breakdown
                  </div>
                  <div class="dq-badges">
                    <span class="badge dq-badge-soft">
                      <i class="ti ti-cash"></i> Gross:
                      {{ money(viewSalarySummaryTotals.gross_salary) }}
                    </span>
                    <span class="badge dq-badge-soft">
                      <i class="ti ti-minus"></i> Deductions:
                      {{ money(viewSalarySummaryTotals.total_deductions) }}
                    </span>
                  </div>
                </div>

                <div class="row g-4">
                  <!-- Earnings -->
                  <div class="col-md-6">
                    <div class="dq-section-title">
                      <i class="ti ti-trending-up"></i> Salary setup (earnings)
                    </div>

                    <div class="dq-table">
                      <div class="dq-row">
                        <div class="dq-k">Basic Salary</div>
                        <div class="dq-v">
                          {{ money(viewSalary.basic_salary) }}
                        </div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">House Allowance</div>
                        <div class="dq-v">
                          {{ money(viewSalary.house_allowance) }}
                        </div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">Transport Allowance</div>
                        <div class="dq-v">
                          {{ money(viewSalary.transport_allowance) }}
                        </div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">Other Allowances</div>
                        <div class="dq-v">
                          {{ money(viewSalary.other_allowance) }}
                        </div>
                      </div>

                      <div class="dq-row dq-total">
                        <div class="dq-k">Setup gross</div>
                        <div class="dq-v">
                          {{ money(viewSalary.gross_salary) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Deductions -->
                  <div class="col-md-6">
                    <div class="dq-section-title">
                      <i class="ti ti-trending-down"></i>
                      {{
                        viewSalaryHasPayrollRun
                          ? "Payroll run (deductions)"
                          : "Deductions"
                      }}
                    </div>

                    <div class="dq-table">
                      <div class="dq-row">
                        <div class="dq-k">NSSF (Employee)</div>
                        <div class="dq-v">{{ money(viewSalarySummaryTotals.nssf) }}</div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">NSSF (Employer)</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.nssf_employer) }}
                        </div>
                      </div>
                      <div
                        class="dq-row"
                        v-if="Number(viewSalarySummaryTotals.nssf_voluntary || 0) > 0"
                      >
                        <div class="dq-k">NSSF Voluntary</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.nssf_voluntary) }}
                        </div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">SHA</div>
                        <div class="dq-v">{{ money(viewSalarySummaryTotals.shif) }}</div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">Housing Levy (Employee)</div>
                        <div class="dq-v">{{ money(viewSalarySummaryTotals.ahl) }}</div>
                      </div>
                      <div
                        class="dq-row"
                        v-if="Number(viewSalarySummaryTotals.pension_contrib || 0) > 0"
                      >
                        <div class="dq-k">Pension Contribution</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.pension_contrib) }}
                        </div>
                      </div>

                      <div class="dq-row"  v-if="Number(viewSalarySummaryTotals.insurance_premium || 0) > 0">
                        <div class="dq-k">Insurance Premium</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.insurance_premium) }}
                        </div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">Mortgage Interest</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.mortgage_interest) }}
                        </div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">SACCO Loan</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.sacco_loan) }}
                        </div>
                      </div>
                      <div class="dq-row">
                        <div class="dq-k">HELB</div>
                        <div class="dq-v">{{ money(viewSalarySummaryTotals.helb) }}</div>
                      </div>

                      <div class="dq-row">
                        <div class="dq-k">Other Loans</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.other_loans) }}
                        </div>
                      </div>

                      <div class="dq-row">
                        <div class="dq-k">General Savings</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.general_savings) }}
                        </div>
                      </div>

                      <div class="dq-row">
                        <div class="dq-k">PAYE</div>
                        <div class="dq-v">{{ money(viewSalarySummaryTotals.paye) }}</div>
                      </div>

                      <div class="dq-row dq-total">
                        <div class="dq-k">Total Deductions</div>
                        <div class="dq-v">
                          {{ money(viewSalarySummaryTotals.total_deductions) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="dq-note mt-3">
                  <i class="ti ti-info-circle"></i>
                  <template v-if="viewSalary?.display_source === 'salary_setup_with_payroll'">
                    Net pay and gross above reflect the
                    {{ viewSalaryPayrollRunTypeLabel }} payroll run for
                    {{ formatPayrollMonth(viewSalary.payroll_run_period || viewSalaryEffectivePeriod) }}.
                    Earnings show the saved salary setup (not the advance payslip layout).
                  </template>
                  <template v-else-if="viewSalary?.display_source === 'payroll_run'">
                    This summary reflects the saved payroll run for
                    {{ formatPayrollMonth(viewSalary.payroll_run_period || viewSalaryEffectivePeriod) }}.
                  </template>
                  <template v-else-if="viewSalary?.statutory_preview">
                    This is the salary setup for
                    {{ formatPayrollMonth(viewSalaryEffectivePeriod) }}.
                    Statutory/net figures are a live preview (same as Edit Salary).
                    Final net pay after Responsibility and other period adjustments
                    appears on Review Payroll once that month is generated.
                  </template>
                  <template v-else>
                    This is the employee salary setup for
                    {{ formatPayrollMonth(viewSalaryEffectivePeriod) }}.
                    Generate payroll for this month to see final run results.
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="dq-empty">
            <i class="ti ti-alert-circle"></i>
            <div class="mt-2">No salary selected.</div>
          </div>
        </div>

        <!-- Footer (sticky) -->
        <div class="dq-modal-footer">
          <button class="btn btn-white border dq-btn" @click="closeViewSalary">
            <i class="ti ti-x me-1"></i> Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Payroll Generation Modal (Upgraded UI + Progress) -->
  <div
    class="modal fade dq-modal"
    id="generate-payroll-modal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl dq-modal-dialog-tall"
    >
      <div class="modal-content dq-modal-content">
        <!-- Header -->
        <div class="dq-modal-header">
          <div class="dq-header-left">
            <div class="dq-modal-icon dq-modal-icon-success">
              <i class="ti ti-calculator"></i>
            </div>
            <div class="dq-header-titles">
              <h4 class="dq-title" style="color: white">
                {{ payrollModalMode === "review" ? "Review Payroll" : "Generate Payroll" }}
              </h4>
              <div class="dq-subtitle">
                {{
                  payrollModalMode === "review"
                    ? "Open an existing generated payroll run for review and approval."
                    : "Run payroll safely with configuration visibility and export tools."
                }}
              </div>
            </div>
          </div>

          <div class="dq-header-right">
            <div class="dq-pill" v-if="currentPayrollPeriodLabel">
              <i class="ti ti-calendar-month"></i>
              <span>{{ currentPayrollPeriodLabel }}</span>
            </div>

            <button
              type="button"
              class="btn btn-icon btn-light dq-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="resetModal"
              :disabled="employeeSalaryStore.loading"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>

        <form @submit.prevent="handleGeneratePayroll">
          <!-- Body -->
          <div class="dq-modal-body dq-scroll">
            <!-- Top Form -->
            <div class="row g-3">
              <div class="col-lg-3">
                <div class="dq-field">
                  <label class="dq-label">Payroll Frequency</label>
                  <template v-if="payrollModalMode === 'review'">
                    <input
                      type="text"
                      class="form-control dq-control"
                      :value="capitalize(payFrequency)"
                      disabled
                    />
                  </template>
                  <select
                    v-else
                    v-model="payFrequency"
                    class="form-select dq-control"
                    :disabled="employeeSalaryStore.loading"
                  >
                    <option value="monthly">Monthly</option>
                    <option value="weekly">Weekly</option>
                    <option value="fortnightly">Fortnightly</option>
                    <option value="daily">Daily</option>
                  </select>
                  <div class="dq-help">
                    Only employees with the same pay frequency are included.
                    Set pay frequency on each employee profile before running.
                  </div>
                </div>
              </div>

              <div class="col-lg-3">
                <div class="dq-field">
                  <label class="dq-label">Payroll Period</label>
                  <select
                    v-if="payFrequency === 'monthly'"
                    class="form-select dq-control"
                    :value="monthlyPeriodSelectValue"
                    :disabled="employeeSalaryStore.loading || payrollPeriodCatalogLoading"
                    required
                    @change="onMonthlyPeriodSelectChange"
                  >
                    <option disabled value="">
                      {{
                        payrollPeriodCatalogLoading
                          ? "Loading months…"
                          : "Select payroll month"
                      }}
                    </option>
                    <option
                      v-for="opt in selectableMonthlyPeriods"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      {{ opt.label }}
                    </option>
                  </select>
                  <div v-else class="row g-2">
                    <div class="col-6">
                      <label class="form-label dq-label mb-1">Start</label>
                      <input
                        v-model="periodStart"
                        type="date"
                        class="form-control dq-control"
                        :disabled="employeeSalaryStore.loading || payrollModalMode === 'review'"
                        required
                      />
                    </div>
                    <div class="col-6">
                      <label class="form-label dq-label mb-1">End</label>
                      <input
                        v-model="periodEnd"
                        type="date"
                        class="form-control dq-control"
                        :disabled="employeeSalaryStore.loading || payFrequency === 'daily' || payrollModalMode === 'review'"
                        required
                      />
                    </div>
                    <div
                      v-if="payrollModalMode !== 'review'"
                      class="col-12 d-flex flex-wrap gap-1 mt-1"
                    >
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        :disabled="employeeSalaryStore.loading"
                        @click="applySuggestedPeriodWindow()"
                      >
                        This {{ payFrequency === "daily" ? "day" : "period" }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        :disabled="employeeSalaryStore.loading"
                        @click="shiftPayrollWindow(-1)"
                      >
                        Previous
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        :disabled="employeeSalaryStore.loading"
                        @click="shiftPayrollWindow(1)"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                  <div class="dq-help">
                    <template v-if="payrollModalMode === 'review'">
                      Only months with a generated payroll run are listed. Closed
                      months stay viewable and cannot be reopened.
                    </template>
                    <template v-else-if="payFrequency === 'monthly'">
                      Closed months are hidden. Pick an open month to generate payroll.
                    </template>
                    <template v-else-if="payFrequency === 'weekly'">
                      Monday–Sunday (7 days). End date auto-fills from start.
                    </template>
                    <template v-else-if="payFrequency === 'fortnightly'">
                      Exactly 14 days. End date auto-fills from start.
                    </template>
                    <template v-else>Daily uses one date for start and end.</template>
                  </div>
                  <div
                    v-if="
                      payrollModalMode === 'review' &&
                      payFrequency === 'monthly' &&
                      !payrollPeriodCatalogLoading &&
                      !selectableMonthlyPeriods.length
                    "
                    class="text-muted small mt-1"
                  >
                    No payroll runs available to review yet.
                  </div>
                  <div
                    v-if="payFrequency !== 'monthly' && previewPeriodCode"
                    class="dq-help mt-1"
                  >
                    Period code: <code>{{ previewPeriodCode }}</code>
                  </div>
                  <div
                    v-if="payFrequency !== 'monthly' && !periodWindowValidation.ok"
                    class="text-danger small mt-1"
                  >
                    {{ periodWindowValidation.message }}
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <!-- Employees (Custom Search Dropdown) -->
                <div class="dq-field position-relative">
                  <EmployeeSelectDropdown
                    v-model="selectedEmployeeIds"
                    :employees="employeeDropdownEmployees"
                    mode="multi"
                    label="Employees"
                    help="Select specific employees or use All Employees."
                    :disabled="employeeSalaryStore.loading || allEmployees || payrollModalMode === 'review'"
                    :treatEmptyAsAll="false"
                  />

                  <!-- Trigger Button -->
                  <!-- <button
                    type="button"
                    class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center dq-employee-btn"
                    @click="toggleEmployeeDropdown"
                    :disabled="employeeSalaryStore.loading || allEmployees"
                  >
                    <span class="text-truncate">
                      <template v-if="allEmployees"> All Employees </template>

                      <template v-else-if="selectedEmployeeIds.length">
                        {{ selectedEmployeeIds.length }} selected
                      </template>

                      <template v-else> Select employees </template>
                    </span>

                    <i class="ti ti-chevron-down"></i>
                  </button> -->

                  <!-- Dropdown -->

                  <!-- Selected pills -->

                  <!-- All employees toggle -->
                  <div class="form-check mt-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="selectAllEmployees"
                      v-model="allEmployees"
                      :disabled="selectedEmployeeIds.length > 0 || payrollModalMode === 'review'"
                      @change="toggleAllEmployees"
                    />
                    <label class="form-check-label" for="selectAllEmployees">
                      All Employees
                    </label>
                  </div>

                  <div class="dq-help">
                    Leave empty or select “All Employees” to include everyone.
                  </div>
                </div>
              </div>

              <div class="col-lg-2">
                <div class="dq-field">
                  <label class="dq-label">Automation</label>

                  <div class="dq-switches">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="emailPayslipsToggle"
                        v-model="emailPayslips"
                        :disabled="employeeSalaryStore.loading || payrollModalMode === 'review'"
                      />
                      <label class="form-check-label" for="emailPayslipsToggle">
                        Email Payslips On Approval
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="payFrequency === 'monthly' && formattedPeriod"
              class="row g-3 mt-1"
            >
              <div class="col-lg-3">
                <div class="dq-field">
                  <label class="dq-label">Run Type</label>
                  <template v-if="payrollModalMode === 'review'">
                    <input
                      type="text"
                      class="form-control dq-control"
                      :value="runTypeLabel"
                      disabled
                    />
                  </template>
                  <select
                    v-else
                    v-model="runType"
                    class="form-select dq-control"
                    :disabled="employeeSalaryStore.loading"
                  >
                    <option
                      v-for="opt in payrollRunTypeOptions"
                      :key="opt.value"
                      :value="opt.value"
                      :disabled="opt.value === 'final' && !canSelectFinalRun"
                    >
                      {{ opt.label }}
                    </option>
                  </select>
                  <div class="dq-help">
                    <template v-if="runType === 'advance'">
                      {{ advanceRunHelpText }}
                    </template>
                    <template v-else-if="runType === 'final'">
                      Processes full statutory deductions and recovers this
                      period’s mid-month advance <strong>in full</strong> (same
                      month only — not installment repayment).
                    </template>
                    <template v-else-if="periodStatus?.advance_run">
                      Select <strong>Month-End Final Payroll</strong> — a
                      mid-month advance has already been paid for this period
                      and must be recovered in full on Final.
                    </template>
                    <template v-else>
                      Standard single-run payroll. Use Mid-Month Advance + Final
                      only when paying cash mid-month that must be recovered in
                      full this month. Multi-month repayment belongs under
                      Employee Loans.
                    </template>
                  </div>
                  <div
                    v-if="runType === 'regular' && periodStatus?.advance_run"
                    class="alert alert-warning py-2 px-3 mt-2 mb-0 small"
                  >
                    <i class="ti ti-alert-triangle me-1"></i>
                    A mid-month advance exists for {{ formattedPeriod }}.
                    <strong>Standard Monthly Payroll will not recover it.</strong>
                    Select <strong>Month-End Final Payroll</strong> to recover
                    the full amount this month.
                  </div>
                  <div
                    v-else-if="!canSelectFinalRun && payrollModalMode !== 'review'"
                    class="text-muted small mt-2"
                  >
                    Month-End Final Payroll becomes available after a mid-month
                    advance is processed for this period (full same-month recovery).
                  </div>
                </div>
              </div>

              <div class="col-lg-5">
                <div class="dq-field">
                  <label class="dq-label">Period Status</label>
                  <div
                    class="d-flex flex-wrap align-items-center gap-2"
                    v-if="periodStatusLoading"
                  >
                    <span class="spinner-border spinner-border-sm"></span>
                    <span class="text-muted small">Loading period status…</span>
                  </div>
                  <div v-else-if="periodStatus" class="d-flex flex-wrap align-items-center gap-2">
                    <span
                      class="badge"
                      :class="periodStatus.status === 'closed' ? 'bg-secondary' : 'bg-success'"
                    >
                      {{ periodStatus.status === 'closed' ? 'Closed' : 'Open' }}
                    </span>
                    <span
                      v-if="periodStatus.advance_run"
                      class="badge bg-info text-dark"
                    >
                      Mid-month advance paid (full recovery on Final)
                    </span>
                    <span
                      v-if="periodStatus.final_run"
                      class="badge bg-primary"
                    >
                      Final run exists
                    </span>
                    <button
                      v-if="showClosePeriodAction"
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      :disabled="closingPeriod || employeeSalaryStore.loading"
                      @click="handleClosePeriod"
                    >
                      <span
                        v-if="closingPeriod"
                        class="spinner-border spinner-border-sm me-1"
                      ></span>
                      Close Period
                    </button>
                  </div>
                  <div v-else class="text-muted small">Select a month to view period status.</div>
                  <div class="dq-help">
                    Close the month after approving the final (or regular) run before starting the next month.
                  </div>
                </div>
              </div>
            </div>

            <div class="card border mt-3 mb-0">
              <div class="card-body py-3">
                <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
                  <div>
                    <h6 class="mb-1">Optional Monthly Adjustments</h6>
                    <div v-if="periodAdjustmentsLoading" class="text-muted small">
                      Loading payroll inputs…
                    </div>
                    <div v-else class="text-muted small">
                      {{ periodAdjustmentSummary.count }} entries:
                      <span class="text-success fw-semibold">
                        +{{ money(periodAdjustmentSummary.additions) }}
                      </span>
                      additions,
                      <span class="text-danger fw-semibold">
                        -{{ money(periodAdjustmentSummary.deductions) }}
                      </span>
                      deductions
                    </div>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary"
                    @click="goToPeriodAdjustments"
                  >
                    Review inputs
                  </button>
                </div>
                <div
                  v-if="!periodAdjustmentsLoading && !periodAdjustmentSummary.count"
                  class="alert alert-warning py-2 mt-2 mb-0 small"
                >
                  No optional monthly adjustments are configured for this run. You can
                  continue normally unless this month has bonuses, responsibility
                  allowances or recoveries.
                </div>
              </div>
            </div>

            <!-- Progress (beautiful) -->
            <div
              v-if="employeeSalaryStore.loading && payrollModalMode !== 'review'"
              class="dq-progress-wrap mt-4"
            >
              <div class="dq-progress-top">
                <div class="dq-progress-title">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Generating payroll…
                </div>
                <div class="dq-progress-pct">{{ payrollProgress }}%</div>
              </div>

              <div class="progress dq-progress">
                <div
                  class="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  :style="{ width: payrollProgress + '%' }"
                  :aria-valuenow="payrollProgress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <div class="dq-progress-steps">
                <div
                  :class="['dq-step', payrollProgress >= 15 ? 'active' : '']"
                >
                  <i class="ti ti-database"></i> Fetching data
                </div>
                <div
                  :class="['dq-step', payrollProgress >= 45 ? 'active' : '']"
                >
                  <i class="ti ti-adjustments"></i> Applying rules
                </div>
                <div
                  :class="['dq-step', payrollProgress >= 70 ? 'active' : '']"
                >
                  <i class="ti ti-receipt"></i> Generating payslips
                </div>
                <div
                  :class="['dq-step', payrollProgress >= 95 ? 'active' : '']"
                >
                  <i class="ti ti-check"></i> Finalizing
                </div>
              </div>

              <!-- <div class="dq-note mt-2">
                <i class="ti ti-info-circle"></i>
                You can close after completion. For best UX, keep this open
                until it hits 100%.
              </div> -->
            </div>

            <!-- Config snapshot (your feature, nicer card) -->
            <div class="dq-card mt-4">
              <div class="dq-card-header">
                <div class="dq-card-title">
                  <i class="ti ti-settings"></i> Payroll Configuration
                </div>

                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary dq-btn"
                  @click="showConfigDetails = !showConfigDetails"
                  :disabled="employeeSalaryStore.loading"
                >
                  <i class="ti ti-info-circle me-1"></i>
                  {{ showConfigDetails ? "Hide Details" : "View Details" }}
                </button>
              </div>

              <div v-if="showConfigDetails" class="dq-config">
                <div class="dq-config-top">
                  <div class="dq-muted fw-semibold">
                    Country / Regime:
                    <span class="badge bg-secondary ms-1">
                      {{ effectiveConfig.country }}
                    </span>
                  </div>
                </div>

                <div class="row g-3">
                  <div class="col-md-4">
                    <div class="dq-config-card">
                      <div class="dq-config-title">NSSF</div>
                      <div class="dq-config-row">
                        Tier I limit:
                        <b>{{ effectiveConfig.nssf.lower_limit }}</b>
                      </div>
                      <div class="dq-config-row">
                        Tier II limit:
                        <b>{{ effectiveConfig.nssf.upper_limit }}</b>
                      </div>
                      <div class="dq-config-row">
                        Rate:
                        <b
                          >{{
                            (effectiveConfig.nssf.rate * 100).toFixed(2)
                          }}%</b
                        >
                      </div>
                      <div class="dq-config-row">
                        Employee cap:
                        <b>{{ effectiveConfig.nssf.employee_cap }}</b>
                      </div>
                      <div class="dq-config-row">
                        Employer match:
                        <b>{{
                          effectiveConfig.nssf.employer_match ? "Yes" : "No"
                        }}</b>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="dq-config-card">
                      <div class="dq-config-title">SHA + Housing Levy</div>
                      <div class="dq-config-row">
                        SHA rate:
                        <b
                          >{{
                            (effectiveConfig.shif.rate * 100).toFixed(2)
                          }}%</b
                        >
                      </div>
                      <div class="dq-config-row">
                        SHA min: <b>{{ effectiveConfig.shif.min }}</b>
                      </div>
                      <div class="dq-divider-sm"></div>
                      <div class="dq-config-row">
                        AHL rate:
                        <b
                          >{{ (effectiveConfig.ahl.rate * 100).toFixed(2) }}%</b
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="dq-config-card">
                      <div class="dq-config-title">PAYE (Summary)</div>
                      <div class="dq-config-row">
                        Personal relief:
                        <b>{{ effectiveConfig.paye.personal_relief }}</b>
                      </div>
                      <div class="dq-config-row">
                        Insurance relief rate:
                        <b
                          >{{
                            (
                              effectiveConfig.paye.insurance_relief_rate * 100
                            ).toFixed(2)
                          }}%</b
                        >
                      </div>
                      <div class="dq-config-row">
                        Insurance relief cap:
                        <b>{{ effectiveConfig.paye.insurance_relief_cap }}</b>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="dq-muted mt-2">
                  These values come from payroll settings; changes affect both
                  previews and generation.
                </div>
              </div>
            </div>

            <div
              v-if="showApprovalProgress"
              class="alert alert-info mt-4"
            >
              <span class="spinner-border spinner-border-sm me-2"></span>
              Approving payroll and finalizing payslips...
            </div>

            <div
              v-if="payrollRunIsPending && employeeSalaryStore.loading"
              class="alert alert-warning mt-3"
            >
              <span class="spinner-border spinner-border-sm me-2"></span>
              Payroll run in progress for this period. Results will appear when
              calculation finishes.
            </div>

            <!-- Errors -->
            <div v-if="formError" class="alert alert-danger mt-3">
              <i class="ti ti-alert-circle me-1"></i> {{ formError }}
            </div>
            <div
              v-if="payrollRunConflict && employeeSalaryStore.error"
              class="alert alert-warning mt-3 d-flex flex-wrap align-items-center gap-2"
            >
              <i class="ti ti-alert-triangle me-1"></i>
              <span>{{ employeeSalaryStore.error }}</span>
              <button
                type="button"
                class="btn btn-sm btn-warning"
                :disabled="employeeSalaryStore.loading"
                @click="forceRecalculatePayroll"
              >
                Force Recalculate
              </button>
            </div>
            <div
              v-else-if="employeeSalaryStore.error"
              class="alert alert-danger mt-3"
            >
              <i class="ti ti-alert-circle me-1"></i>
              {{ employeeSalaryStore.error }}
            </div>

            <!-- Results -->
            <div v-if="payrollResults.length" class="dq-card mt-4">
              <div class="dq-card-header">
                <div>
                  <div class="dq-card-title">
                    <i class="ti ti-table"></i>
                    Payroll Results
                    <span class="badge bg-primary ms-2">{{
                      currentPayrollPeriod
                    }}</span>
                  </div>
                  <div class="dq-muted small">
                    Total Employees: <b>{{ payrollResults.length }}</b>
                  </div>
                  <div class="dq-muted small mt-1">
                    Approval Status:
                    <span
                      class="badge ms-1"
                      :class="
                        payrollApprovalStatus === 'approved'
                          ? 'bg-success'
                          : 'bg-warning text-dark'
                      "
                    >
                      {{ payrollApprovalStatusLabel }}
                    </span>
                    <template v-if="payrollApproverName">
                      by <b>{{ payrollApproverName }}</b>
                    </template>
                  </div>
                  <div v-if="payrollCreatorName" class="dq-muted small mt-1">
                    Prepared By: <b>{{ payrollCreatorName }}</b>
                  </div>
                  <div
                    v-if="requireSeparateApprover && isPayrollMaker"
                    class="dq-muted small mt-1"
                  >
                    You prepared this payroll run. Another authorized approver
                    must approve it.
                  </div>
                  <div
                    v-else-if="!requireSeparateApprover"
                    class="dq-muted small mt-1"
                  >
                    Separate approver is disabled for this company. Tenant
                    Admins can run and approve payroll themselves.
                  </div>
                </div>

                <div
                  v-if="
                    payrollApprovalStatus === 'approved' &&
                    cashPaidEmployeeCount > 0
                  "
                  class="alert alert-info mt-3 mb-0"
                >
                  <i class="ti ti-cash me-1"></i>
                  {{ cashPaidEmployeeCount }} employee(s) are paid in cash for
                  this period.
                  <a
                    href="#"
                    class="alert-link ms-1"
                    @click.prevent="goToReportFromPayrollModal(cashPayrollReportLocation)"
                  >
                    Open Cash Payroll Register
                  </a>
                  to acknowledge handover after approval.
                </div>

                <div
                  v-if="showBankTransferShortcut"
                  class="alert alert-success mt-3 mb-0"
                >
                  <i class="ti ti-building-bank me-1"></i>
                  {{ bankPaidEmployeeCount }} employee(s) are paid via bank for
                  this period.
                  <a
                    href="#"
                    class="alert-link ms-1"
                    @click.prevent="goToReportFromPayrollModal(bankTransferReportLocation)"
                  >
                    Open Bank Transfer Report
                  </a>
                  to download the bank upload file (CSV or Excel).
                </div>

                <div
                  v-if="showCheckPayrollShortcut"
                  class="alert alert-warning mt-3 mb-0"
                >
                  <i class="ti ti-file-invoice me-1"></i>
                  {{ checkPaidEmployeeCount }} employee(s) are paid by check for
                  this period.
                  <a
                    href="#"
                    class="alert-link ms-1"
                    @click.prevent="goToReportFromPayrollModal(checkPayrollReportLocation)"
                  >
                    Open Check Payroll Register
                  </a>
                  to record check numbers after approval.
                </div>

                <div class="d-flex gap-2 align-items-center flex-wrap">
                  <button
                    v-if="canApprovePayroll"
                    class="btn btn-success btn-sm dq-btn"
                    @click.prevent="approveCurrentPayroll"
                  >
                    <i class="ti ti-checks me-1"></i> Approve Payroll
                  </button>

                  <button
                    class="btn btn-outline-secondary btn-sm dq-btn"
                    @click.prevent="exportPayrollCSV"
                  >
                    <i class="ti ti-file-type-xls me-1"></i> Export CSV
                  </button>

                  <button
                    class="btn btn-outline-primary btn-sm dq-btn"
                    :disabled="
                      !payrollResults.length ||
                      payrollApprovalStatus !== 'approved'
                    "
                    @click.prevent="downloadAllPayslips"
                  >
                    <i class="ti ti-download me-1"></i> Download All
                  </button>

                  <router-link
                    v-if="showBankTransferShortcut"
                    :to="bankTransferReportLocation"
                    class="btn btn-outline-primary btn-sm dq-btn"
                  >
                    <i class="ti ti-building-bank me-1"></i> Bank transfer file
                  </router-link>
                </div>
              </div>

              <div class="table-responsive dq-table-wrap">
                <table class="table table-hover align-middle mb-0 dq-payroll-results">
                  <thead>
                    <tr>
                      <th class="dq-payroll-employee">Employee</th>
                      <th class="text-end">Gross</th>
                      <th class="text-end">NSSF</th>
                      <th class="text-end">SHA</th>
                      <th class="text-end">AHL</th>
                      <th class="text-end">PAYE</th>
                      <th class="text-end">HELB</th>
                      <th class="text-end">Deductions</th>
                      <th class="text-end">Net Pay</th>
                      <th>Payslip</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in payrollResults" :key="row.employee_id">
                      <td class="dq-payroll-employee">
                        <div class="fw-semibold dq-payroll-name">
                          {{ payrollResultEmployeeName(row) }}
                        </div>
                        <div class="dq-muted small">
                          {{
                            row.employee?.employee_id ||
                            row.employee_code ||
                            row.employee_id ||
                            "—"
                          }}
                        </div>
                        <div
                          v-if="payrollResultNotes(row).length"
                          class="dq-payroll-notes"
                        >
                          <span
                            v-for="note in payrollResultNotes(row)"
                            :key="note.key"
                            class="dq-payroll-note"
                            :title="note.text"
                          >
                            {{ note.text }}
                          </span>
                        </div>
                      </td>

                      <td class="text-end">
                        {{ money(row.breakdown.gross_salary) }}
                      </td>
                      <td class="text-end">{{ money(row.breakdown.nssf) }}</td>
                      <td class="text-end">{{ money(row.breakdown.shif) }}</td>
                      <td class="text-end">{{ money(row.breakdown.ahl) }}</td>
                      <td class="text-end">{{ money(row.breakdown.paye) }}</td>
                      <td class="text-end">{{ money(row.breakdown.helb) }}</td>
                      <td class="text-end">
                        {{ money(row.breakdown.total_deductions) }}
                      </td>
                      <td class="text-end fw-bold text-success">
                        {{ money(row.breakdown.net_pay) }}
                      </td>

                      <td class="dq-payroll-payslip">
                        <div
                          v-if="payrollApprovalStatus !== 'approved'"
                          class="d-flex flex-column gap-1"
                        >
                          <span class="dq-muted small">Approve to issue final payslips</span>
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            :disabled="!row.id || previewingPayslipId === row.id"
                            @click.stop.prevent="previewPayslipFromResult(row)"
                          >
                            <span
                              v-if="previewingPayslipId === row.id"
                              class="spinner-border spinner-border-sm me-1"
                            ></span>
                            <i v-else class="ti ti-eye me-1"></i>
                            Preview
                          </button>
                        </div>

                        <div v-else-if="row.payslip">
                          <span
                            class="badge"
                            :class="{
                              'bg-success': row.payslip.status === 'emailed',
                              'bg-info':
                                row.payslip.status === 'generated' &&
                                !row.payslip.emailed_at,
                              'bg-warning': row.payslip.status === 'failed',
                            }"
                          >
                            {{ row.payslip.status }}
                          </span>

                          <div class="mt-2 d-flex gap-2">
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-sm dq-icon-btn"
                              @click.stop.prevent="
                                downloadPayslipById(row.payslip.id)
                              "
                            >
                              <i class="ti ti-download"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-secondary btn-sm dq-icon-btn"
                              @click.stop.prevent="
                                resendPayslipEmail(row.payslip.id)
                              "
                            >
                              <i class="ti ti-mail"></i>
                            </button>
                          </div>

                          <div
                            class="dq-muted small mt-2"
                            v-if="row.payslip.emailed_at"
                          >
                            Emailed: {{ formatDate(row.payslip.emailed_at) }}
                          </div>
                        </div>

                        <div v-else class="dq-muted">Generating...</div>

                        <div
                          v-if="row.status === 'failed'"
                          class="text-danger small mt-2"
                        >
                          {{ row.error || "Failed to compute" }}
                          <button
                            class="btn btn-link p-0 ms-1"
                            :disabled="retryingEmployees[row.employee_id]"
                            @click="retryEmployee(row.employee_id)"
                          >
                            {{
                              retryingEmployees[row.employee_id]
                                ? "Retrying..."
                                : "Retry"
                            }}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              v-else-if="payrollRunTriggered && !employeeSalaryStore.loading"
              class="alert alert-info mt-4"
            >
              <i class="ti ti-info-circle me-1"></i>
              No payroll generated for the selected period/employees.
            </div>
          </div>

          <!-- Footer (sticky) -->
          <div class="dq-modal-footer">
            <button
              type="button"
              class="btn btn-white border dq-btn"
              data-bs-dismiss="modal"
              @click="resetModal"
              :disabled="employeeSalaryStore.loading"
            >
              <i class="ti ti-x me-1"></i> Close
            </button>

            <button
              v-if="payrollModalMode === 'review' && showClosePeriodAction"
              type="button"
              class="btn btn-outline-secondary dq-btn"
              :disabled="closingPeriod || employeeSalaryStore.loading"
              @click="handleClosePeriod"
            >
              <span
                v-if="closingPeriod"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              <i v-else class="ti ti-lock me-1"></i>
              Close Period
            </button>

            <button
              v-if="payrollModalMode !== 'review'"
              :disabled="employeeSalaryStore.loading"
              type="submit"
              class="btn btn-success dq-btn"
            >
              <span
                v-if="employeeSalaryStore.loading"
                class="spinner-border spinner-border-sm me-2"
              ></span>
              <i class="ti ti-calculator me-1"></i>
              {{ employeeSalaryStore.loading ? "Running..." : "Run Payroll" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Payslip preview (no extra backdrop when opened over Review modal) -->
  <div
    class="modal fade"
    id="payslip-preview-modal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="false"
    data-bs-keyboard="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
      <div class="modal-content border-0 shadow">
        <div class="modal-header">
          <div>
            <h5 class="modal-title mb-0">{{ payslipPreviewTitle }}</h5>
            <small class="text-muted">
              Preview only — approve payroll to issue and email final payslips.
            </small>
          </div>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            @click="closePayslipPreview"
          ></button>
        </div>
        <div class="modal-body p-0" style="min-height: 70vh; background: #f8fafc">
          <iframe
            v-if="payslipPreviewUrl"
            :src="payslipPreviewUrl"
            title="Payslip preview"
            style="width: 100%; height: 70vh; border: 0; background: #fff"
          ></iframe>
          <div v-else class="text-center text-muted py-5">Loading preview…</div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            @click="closePayslipPreview"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <PayrollClosePeriodConfirmModal
    ref="closePeriodConfirmRef"
    @confirmed="onClosePeriodConfirmed"
  />
  <PayrollAdvanceRegularRunConfirmModal
    ref="advanceRegularRunConfirmRef"
    @confirmed="onAdvanceRegularRunConfirmed"
    @switch-to-final="onAdvanceRunSwitchToFinal"
  />
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted, computed, nextTick, onBeforeUnmount, watch } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { useAuthStore } from "@/stores/authStore";
import { useDesignationStore } from "@/stores/designationStore";
import { useEmployeeStore } from "@/stores/employeeStore";
import { useEmployeeSalaryStore } from "@/stores/employeeSalaryStore";
import { storeToRefs } from "pinia";
import EmployeeSalaryModal from "@/components/modal/employee-salary-modal.vue";
import PayrollClosePeriodConfirmModal from "@/components/modal/payroll-close-period-confirm-modal.vue";
import PayrollAdvanceRegularRunConfirmModal from "@/components/modal/payroll-advance-regular-run-confirm-modal.vue";
import payrollService from "@/services/payroll.service";
import employeeSalaryService from "@/services/hrm/employee-salary.service";
import payrollComponentEntryService from "@/services/payrollComponentEntry.service";
import { toast } from "@/utils/toast";
import { useCompanyStore } from "@/stores/companyStore";
import { usePayrollConfigStore } from "@/stores/payrollConfigStore";
import EmployeeSelectDropdown from "@/components/common/EmployeeSelectDropdown.vue";
import DqAvatar from "@/components/shared/DqAvatar.vue";
import {
  validateFrequencyWindow,
  buildPeriodCodePreview,
  suggestPeriodWindow,
  shiftPeriodWindow,
  endDateForFrequency,
  toYYYYMM,
  currentPayrollYYYYMM,
  formatPayrollMonthLabel,
} from "@/utils/payrollPeriodHelpers";
import {
  PAYROLL_RUN_TYPE_OPTIONS,
  getPayrollRunTypeLabel,
  buildMonthlyPeriodCode,
} from "@/utils/payrollRunTypes";

//import Modal from "bootstrap/js/dist/modal";
import { Modal } from "bootstrap";
import {
  clearBootstrapModalResidue,
  hideBootstrapModalById,
} from "@/utils/bootstrapModal";

const router = useRouter();

async function goToReportFromPayrollModal(location) {
  await hideBootstrapModalById("generate-payroll-modal");
  clearBootstrapModalResidue();
  router.push(location);
}

function goToPeriodAdjustments() {
  const el = document.getElementById("generate-payroll-modal");
  const modal = el ? Modal.getInstance(el) : null;
  if (modal) {
    el?.addEventListener(
      "hidden.bs.modal",
      () => {
        clearBootstrapModalResidue();
        router.push({
          path: "/payroll/period-adjustments",
          query: currentPayrollPeriod.value
            ? { period: currentPayrollPeriod.value }
            : {},
        });
      },
      { once: true },
    );
    modal.hide();
    return;
  }

  clearBootstrapModalResidue();
  router.push({
    path: "/payroll/period-adjustments",
    query: currentPayrollPeriod.value
      ? { period: currentPayrollPeriod.value }
      : {},
  });
}

// --- STATIC DATA ---
const columns = [
  {
    sorter: false,
  },
  {
    title: "Emp ID",
    dataIndex: "EmpID",
    sorter: {
      compare: (a, b) => {
        a = a.EmpID.toLowerCase();
        b = b.EmpID.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
    sorter: {
      compare: (a, b) => {
        a = a.Name.toLowerCase();
        b = b.Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Email",
    dataIndex: "Email",
    sorter: {
      compare: (a, b) => {
        a = a.Email.toLowerCase();
        b = b.Email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Phone",
    dataIndex: "Phone",
    sorter: {
      compare: (a, b) => {
        a = a.Phone.toLowerCase();
        b = b.Phone.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Designation",
    dataIndex: "Designation",
    key: "Designation",
    sorter: {
      compare: (a, b) => {
        a = a.Designation.toLowerCase();
        b = b.Designation.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Joining Date",
    dataIndex: "JoiningDate",
    key: "JoiningDate",
    sorter: {
      compare: (a, b) => {
        a = a.JoiningDate.toLowerCase();
        b = b.JoiningDate.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Payslip",
    dataIndex: "Payslip",
    key: "Payslip",
    sorter: {
      compare: (a, b) => {
        a = String(a.Payslip || "").toLowerCase();
        b = String(b.Payslip || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: false,
  },
];

// --- STORES & REFS ---
const designationStore = useDesignationStore();
const { designations } = storeToRefs(designationStore);
const employeeStore = useEmployeeStore();
const { employees } = storeToRefs(employeeStore);
const employeeSalaryStore = useEmployeeSalaryStore();
const { salaries } = storeToRefs(employeeSalaryStore);

const companyStore = useCompanyStore();
const { companies, activeCompanyId } = storeToRefs(companyStore);

const activeCompany = computed(() =>
  companies.value.find((c) => c.id === activeCompanyId.value),
);

const companyCurrencySymbol = computed(() => {
  const c = activeCompany.value;
  // adjust field names to your Company model; this is an example
  return c?.currency_symbol || c?.currency_code || "KES";
});

const authStore = useAuthStore();
const { user: authUser } = storeToRefs(authStore);
const authRoles = computed(() =>
  (authUser.value?.roles || []).map((r) => (typeof r === "string" ? r : r.name)),
);
const authPermissions = computed(() =>
  (authUser.value?.permissions || []).map((p) =>
    typeof p === "string" ? p : p?.name,
  ),
);
const isSuperAdmin = computed(() => {
  return authRoles.value.includes("SuperAdmin");
});
const canApprovePayrollRole = computed(
  () =>
    authRoles.value.includes("Admin") ||
    authPermissions.value.includes("Payroll.Approve"),
);

const showEmployeeDropdown = ref(false);
const employeeSearch = ref("");

const filteredEmployees = computed(() => {
  const q = employeeSearch.value.toLowerCase().trim();
  if (!q) return frequencyMatchedEmployeeOptions.value;

  return frequencyMatchedEmployeeOptions.value.filter((e) =>
    e.text.toLowerCase().includes(q),
  );
});

const selectedEmployeesPreview = computed(() =>
  frequencyMatchedEmployeeOptions.value.filter((e) =>
    selectedEmployeeIds.value.includes(e.id),
  ),
);

function toggleEmployeeDropdown() {
  showEmployeeDropdown.value = !showEmployeeDropdown.value;
}

function onEmployeePicked() {
  if (selectedEmployeeIds.value.length > 0) {
    allEmployees.value = false;
  }
}

function removeEmployee(id) {
  selectedEmployeeIds.value = selectedEmployeeIds.value.filter((x) => x !== id);
}

const employeeDropdownEmployees = computed(() =>
  frequencyMatchedEmployees.value.map((e) => ({
    id: Number(e.id),
    name: `${e.first_name} ${e.last_name || ""}`.trim(),
    employee_id: e.employee_id,
    avatar_url: e.avatar_url || "",
    department: e.department?.name || "",
    designation: e.designation?.name || "",
  })),
);

function toggleAllEmployees() {
  if (allEmployees.value) {
    selectedEmployeeIds.value = [];
    showEmployeeDropdown.value = false;
  }
}

// ✅ Payroll config store (source of truth)
const payrollConfigStore = usePayrollConfigStore();
const { config: payrollConfig } = storeToRefs(payrollConfigStore);

// UI toggle for snapshot
const showConfigDetails = ref(false);

// --- LOCAL STATE ---

// Payroll form state
const period = ref(null);
const payFrequency = ref("monthly");
const runType = ref("regular");
const periodStart = ref("");
const periodEnd = ref("");
const periodStatus = ref(null);
const periodStatusLoading = ref(false);
const payrollPeriodCatalog = ref([]);
const payrollPeriodCatalogLoading = ref(false);
const listPeriod = ref(currentPayrollYYYYMM());
const listSearch = ref("");
const closingPeriod = ref(false);
const closePeriodConfirmRef = ref(null);
const advanceRegularRunConfirmRef = ref(null);
const selectedEmployeeIds = ref([]);
const allEmployees = ref(true);
const formError = ref("");
const payrollRunTriggered = ref(false);
const emailPayslips = ref(true);
const forceRun = ref(true);
const payslipGenerating = ref({});
const previewingPayslipId = ref(null);
const payslipPreviewUrl = ref("");
const payslipPreviewTitle = ref("Payslip preview");
const retryingEmployees = ref({});
const payrollRunConflict = ref(false);
const approvalNotes = ref("");
const latestReviewablePayrollRun = ref(null);
const payrollModalMode = ref("generate");
const approvingPayroll = ref(false);

const tableData = computed(() =>
  salaries.value.map((e) => {
    const rowPeriod =
      e.list_period || listPeriod.value || currentPayrollYYYYMM();
    const salaryPeriod = e.payroll_month
      ? String(e.payroll_month).slice(0, 7)
      : null;

    return {
      _raw: e,
      id: e.id,
      key: `${e.employee_id || e.employee?.id || e.id}-${rowPeriod}`,
      EmpID: e.employee.employee_id,
      Name: e.employee.first_name + " " + (e.employee.last_name || ""),
      Work: e.employee.department?.name || "",
      Email: e.employee.email,
      Phone: e.employee.phone,
      Designation: e.employee.designation?.name || "",
      JoiningDate: e.employee.company_doj
        ? new Date(e.employee.company_doj).toLocaleDateString()
        : "",
      Salary: e.basic_salary
        ? `${companyCurrencySymbol.value} ${Number(
            e.basic_salary,
          ).toLocaleString()}`
        : "",

      Status: e.employee.status,
      Image: e?.employee.avatar_url || "",
      designation_id: e.employee.designation_id,
      department_id: e.employee.department_id,
      username: e.employee.username,
      first_name: e.employee.first_name,
      last_name: e.employee.last_name,
      email: e.employee.email,
      phone: e.employee.phone,
      company_doj: e.employee.company_doj,
      status: e.employee.status,
      image_url: e.employee.avatar_url,
      employee_id: e.employee.employee_id,
      permissions: e?.employee?.user?.permissions,
      about: e.employee.about,
      company: e.employee.company,
      listPeriod: rowPeriod,
      hasSalaryForPeriod: e.has_salary_for_period !== false,
      payrollRunStatus: e.payroll_run_status || null,
      payrollApprovalStatus: e.payroll_approval_status || "pending_approval",
      payrollResultId: e.payroll_result?.id || null,
      payslipId: e.payroll_result?.payslip?.id || null,
      payslipPeriodLabel: (() => {
        if (
          e.has_salary_for_period === false &&
          salaryPeriod &&
          !e.payroll_run_status
        ) {
          return `Setup: ${moment(salaryPeriod, "YYYY-MM").format("MMMM YYYY")}`;
        }
        const payslipStatus = e.payroll_result?.payslip?.status;
        if (payslipStatus === "emailed") return "Emailed";
        if (payslipStatus === "generated") return "Ready to download";
        return "";
      })(),
      canGenerateSlip:
        e.payroll_run_status === "completed" &&
        e.payroll_approval_status === "approved" &&
        !!e.payroll_result?.id,
      payslipTone: (() => {
        if (
          e.payroll_run_status === "completed" &&
          e.payroll_approval_status === "approved" &&
          e.payroll_result?.payslip?.id
        ) {
          return "download";
        }
        if (
          e.payroll_run_status === "completed" &&
          e.payroll_approval_status === "approved" &&
          e.payroll_result?.id
        ) {
          return "generate";
        }
        if (e.payroll_run_status === "completed") {
          return "awaiting_approval";
        }
        if (e.payroll_run_status && e.payroll_run_status !== "completed") {
          return "in_progress";
        }
        return "awaiting_payroll";
      })(),
      Payslip:
        e.payroll_run_status === "completed" &&
        e.payroll_approval_status === "approved" &&
        e.payroll_result?.payslip?.id
          ? "Download Slip"
          : e.payroll_run_status === "completed" &&
              e.payroll_approval_status === "approved" &&
              e.payroll_result?.id
            ? "Generate Slip"
            : e.payroll_run_status === "completed" && e.payroll_result?.id
              ? "Preview / Awaiting Approval"
              : e.payroll_run_status === "completed"
                ? "Awaiting Approval"
                : awaitingPayrollLabel(rowPeriod),
      canPreviewSlip:
        e.payroll_run_status === "completed" &&
        e.payroll_approval_status !== "approved" &&
        !!e.payroll_result?.id,
    };
  }),
);

const filteredTableData = computed(() => {
  const q = String(listSearch.value || "")
    .trim()
    .toLowerCase();
  if (!q) return tableData.value;
  return tableData.value.filter((row) => {
    const haystack = [
      row.Name,
      row.EmpID,
      row.Email,
      row.Phone,
      row.Designation,
      row.Work,
      row.first_name,
      row.last_name,
      row.employee_id,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return haystack.includes(q);
  });
});

const hasSalaryRows = computed(() => Array.isArray(salaries.value) && salaries.value.length > 0);

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

// Misc UI state
const title = ref("Employee Salary");
const text = ref("Employees");
const text1 = ref("Employee Salary");
const dateRangeInput = ref(null);

function booking_range(start, end) {
  return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
}

function fetchSalaries() {
  const period = toYYYYMM(listPeriod.value) || currentPayrollYYYYMM();
  if (period && listPeriod.value !== period) {
    listPeriod.value = period;
  }
  employeeSalaryStore.fetchSalaries({ period });
}

watch(listPeriod, (next, prev) => {
  const period = toYYYYMM(next);
  if (!period || period === toYYYYMM(prev)) return;
  fetchSalaries();
});

function formatPayrollMonth(val) {
  return formatPayrollMonthLabel(val);
}

function awaitingPayrollLabel(periodValue) {
  const ym =
    toYYYYMM(periodValue) ||
    currentPayrollPeriod.value ||
    formattedPeriod.value ||
    currentPayrollYYYYMM();
  return `Awaiting ${formatPayrollMonthLabel(ym)} payroll`;
}

function payrollResultNotes(row) {
  const notes = [];

  for (const ot of row?.applied_overtime || []) {
    notes.push({
      key: `ot-${ot.source_id ?? ot.name}`,
      text: `OT ${ot.name} ${ot.hours}h ${money(ot.amount)}`,
    });
  }

  for (const add of row?.applied_additions || []) {
    notes.push({
      key: `add-${add.source_id ?? add.name}`,
      text: `${add.name} ${money(add.amount)}`,
    });
  }

  for (const ded of row?.applied_deductions || []) {
    notes.push({
      key: `ded-${ded.source_id ?? ded.name}`,
      text: `${deductionSourceLabel(ded)}${ded.name} ${money(ded.amount)}`,
    });
  }

  return notes;
}

function deductionSourceLabel(deduction) {
  const category = String(deduction?.category || "").toLowerCase();
  const labels = {
    attendance: "Attendance - ",
    leave: "Unpaid Leave - ",
    timesheet: "Timesheet - ",
    loan: "Loan - ",
    savings: "Savings - ",
    payroll_deduction: "Payroll Deduction - ",
  };

  return labels[category] || "";
}

function isGeneratingPayslip(row) {
  const employeeId = row?.employee?.id ?? row?.employee_id ?? row?.id;
  if (!employeeId) return false;
  return !!payslipGenerating.value[employeeId];
}

function payslipBadgeClass(record) {
  if (isGeneratingPayslip(record?._raw)) return "badge-secondary";

  switch (record?.payslipTone) {
    case "download":
      return "badge-success";
    case "generate":
      return "badge-primary";
    case "awaiting_approval":
      return "badge-warning";
    case "in_progress":
      return "badge-info";
    case "awaiting_payroll":
    default:
      return "badge-light text-dark";
  }
}

async function openPayslipPreviewBlob(blob, title = "Payslip preview") {
  if (payslipPreviewUrl.value) {
    URL.revokeObjectURL(payslipPreviewUrl.value);
    payslipPreviewUrl.value = "";
  }
  payslipPreviewTitle.value = title;
  payslipPreviewUrl.value = URL.createObjectURL(blob);
  await nextTick();
  const el = document.getElementById("payslip-preview-modal");
  if (!el) return;
  // Nested under review modal: no extra backdrop (avoids double dim / stuck overlays).
  const modal = Modal.getOrCreateInstance(el, {
    backdrop: false,
    focus: true,
  });
  modal.show();
}

function closePayslipPreview() {
  const el = document.getElementById("payslip-preview-modal");
  if (el) {
    const modal = Modal.getInstance(el) || Modal.getOrCreateInstance(el);
    modal.hide();
  }
  if (payslipPreviewUrl.value) {
    URL.revokeObjectURL(payslipPreviewUrl.value);
    payslipPreviewUrl.value = "";
  }
  // Keep parent review modal visible; only clear orphaned backdrops.
  document.querySelectorAll(".modal-backdrop").forEach((node, index, list) => {
    if (index < list.length - 1) node.remove();
  });
}

async function previewPayslipFromResult(row) {
  const resultId = row?.id || row?.payroll_result_id;
  if (!resultId) {
    toast("No payroll result available to preview.", "error");
    return;
  }
  previewingPayslipId.value = resultId;
  try {
    const { data, headers } = await payrollService.previewPayslip({
      payroll_result_id: resultId,
    });
    if (data?.type && String(data.type).includes("application/json")) {
      const text = await data.text();
      const parsed = JSON.parse(text);
      throw new Error(parsed?.message || "Failed to load payslip preview.");
    }
    void headers;
    const name = payrollResultEmployeeName(row);
    await openPayslipPreviewBlob(data, `Payslip preview — ${name}`);
  } catch (error) {
    toast(
      error?.message ||
        error?.response?.data?.message ||
        "Failed to load payslip preview.",
      "error",
    );
  } finally {
    previewingPayslipId.value = null;
  }
}

async function previewPayslipFromSalaryRow(record) {
  const raw = record?._raw || record;
  const resultId = raw?.payroll_result?.id || record?.payrollResultId;
  if (!resultId) {
    toast("No payroll result available to preview.", "error");
    return;
  }
  previewingPayslipId.value = resultId;
  try {
    const { data } = await payrollService.previewPayslip({
      payroll_result_id: resultId,
    });
    if (data?.type && String(data.type).includes("application/json")) {
      const text = await data.text();
      const parsed = JSON.parse(text);
      throw new Error(parsed?.message || "Failed to load payslip preview.");
    }
    const name =
      record?.Name ||
      `${raw?.employee?.first_name || ""} ${raw?.employee?.last_name || ""}`.trim() ||
      "Employee";
    await openPayslipPreviewBlob(data, `Payslip preview — ${name}`);
  } catch (error) {
    toast(
      error?.message ||
        error?.response?.data?.message ||
        "Failed to load payslip preview.",
      "error",
    );
  } finally {
    previewingPayslipId.value = null;
  }
}

const viewSalaryEffectivePeriod = computed(() => {
  const s = viewSalary.value;
  if (!s) return "";
  return s.payroll_run_period || toYYYYMM(s.payroll_month);
});

const viewSalaryPeriodMismatch = computed(() => {
  const s = viewSalary.value;
  if (!s?.payroll_run_period) return false;
  return toYYYYMM(s.payroll_month) !== s.payroll_run_period;
});

const canUseViewSalaryPayslipAction = computed(
  () =>
    !!viewSalary.value?.payroll_result?.id &&
    viewSalary.value?.payroll_run_status === "completed" &&
    viewSalary.value?.payroll_approval_status === "approved",
);

const viewSalaryPayslipLabel = computed(() => {
  if (!viewSalary.value) {
    return awaitingPayrollLabel(currentPayrollPeriod.value);
  }
  if (viewSalary.value?.payroll_run_status !== "completed") {
    return awaitingPayrollLabel(
      currentPayrollPeriod.value ||
        viewSalary.value?.payroll_run_period ||
        viewSalary.value?.payroll_month,
    );
  }
  if (viewSalary.value?.payroll_approval_status !== "approved") {
    return "Awaiting Approval";
  }
  if (!canUseViewSalaryPayslipAction.value) return "Awaiting Approval";
  return viewSalary.value?.payroll_result?.payslip?.id
    ? "Download Payslip"
    : "Generate Payslip";
});

function buildPayrollTotalsFromResult(salary) {
  const result = salary?.payroll_result;
  if (!result) {
    return null;
  }
  const breakdown =
    result.breakdown && typeof result.breakdown === "object"
      ? result.breakdown
      : {};
  const num = (value) => Number(value) || 0;
  const pick = (key) => {
    if (result[key] != null && result[key] !== "") {
      return num(result[key]);
    }
    if (breakdown[key] != null && breakdown[key] !== "") {
      return num(breakdown[key]);
    }
    return num(salary?.[key]);
  };

  return {
    gross_salary: pick("gross_salary"),
    net_pay: pick("net_pay"),
    taxable_income: pick("taxable_income"),
    total_deductions: pick("total_deductions"),
    basic_salary: pick("basic_salary"),
    house_allowance: pick("house_allowance"),
    transport_allowance: pick("transport_allowance"),
    other_allowance: pick("other_allowance"),
    nssf: pick("nssf"),
    nssf_employer: pick("nssf_employer"),
    nssf_voluntary: pick("nssf_voluntary"),
    shif: pick("shif"),
    ahl: pick("ahl"),
    pension_contrib: pick("pension_contrib"),
    insurance_premium: pick("insurance_premium"),
    mortgage_interest: pick("mortgage_interest"),
    sacco_loan: pick("sacco_loan"),
    helb: pick("helb"),
    other_loans: pick("other_loans"),
    general_savings: pick("general_savings"),
    paye: pick("paye"),
    run_type:
      salary?.payroll_result?.payroll_run?.run_type ||
      breakdown.run_type ||
      "regular",
  };
}

const viewSalaryPayrollTotals = computed(() =>
  buildPayrollTotalsFromResult(viewSalary.value),
);

const viewSalarySummaryTotals = computed(() => {
  const s = viewSalary.value;
  if (!s) {
    return {};
  }
  if (viewSalaryPayrollTotals.value) {
    return viewSalaryPayrollTotals.value;
  }
  return {
    gross_salary: s.gross_salary,
    net_pay: s.net_pay,
    taxable_income: s.taxable_income,
    total_deductions: s.total_deductions,
    nssf: s.nssf,
    nssf_employer: s.nssf_employer,
    nssf_voluntary: s.nssf_voluntary,
    shif: s.shif,
    ahl: s.ahl,
    pension_contrib: s.pension_contrib,
    insurance_premium: s.insurance_premium,
    mortgage_interest: s.mortgage_interest,
    sacco_loan: s.sacco_loan,
    helb: s.helb,
    other_loans: s.other_loans,
    general_savings: s.general_savings,
    paye: s.paye,
  };
});

const viewSalaryHasPayrollRun = computed(
  () =>
    !!viewSalary.value?.payroll_result?.id &&
    viewSalary.value?.payroll_run_status === "completed" &&
    Number(viewSalaryPayrollTotals.value?.net_pay || 0) > 0,
);

const viewSalaryPayrollRunTypeLabel = computed(() => {
  const runType = viewSalaryPayrollTotals.value?.run_type || "regular";
  return getPayrollRunTypeLabel(runType);
});

async function fetchSalarySetupForModal(row) {
  const src = row?._raw || row;
  if (!src?.id) {
    return src ? { ...src } : null;
  }
  const period =
    currentPayrollPeriod.value ||
    src.list_period ||
    toYYYYMM(src.payroll_month) ||
    "";
  const params = { context: "setup" };
  if (period) {
    params.period = period;
  }
  const { data } = await employeeSalaryService.show(src.id, params);
  return data;
}

// function formatPayrollMonth(val) {
//   if (!val) return "-";
//   try {
//     // val can be "2025-11-01T..." or "2025-11"
//     const s = typeof val === "string" ? val : String(val);
//     const y = s.slice(0, 4);
//     const m = s.slice(5, 7);
//     return `${y}-${m}`; // e.g. 2025-11
//   } catch {
//     return val;
//   }
// }

// --- Payroll progress (UI only; simulates progress during run/poll) ---
const payrollProgress = ref(0);
let payrollProgressTimer = null;

function startPayrollProgress() {
  stopPayrollProgress();
  payrollProgress.value = 8;

  payrollProgressTimer = setInterval(() => {
    // Smooth fake progress that slows down near the end until results arrive
    const p = payrollProgress.value;
    if (p < 45) payrollProgress.value += 4;
    else if (p < 70) payrollProgress.value += 2;
    else if (p < 90) payrollProgress.value += 1;
    else if (p < 96) payrollProgress.value += 0.5;
  }, 450);
}

function finishPayrollProgress() {
  stopPayrollProgress();
  payrollProgress.value = 100;
  setTimeout(() => {
    payrollProgress.value = 0;
  }, 800);
}

function stopPayrollProgress() {
  if (payrollProgressTimer) {
    clearInterval(payrollProgressTimer);
    payrollProgressTimer = null;
  }
}

function payrollPeriodToDate(periodValue) {
  if (!periodValue) return null;
  if (periodValue instanceof Date) return periodValue;
  if (typeof periodValue === "string") {
    const [year, month] = periodValue.slice(0, 7).split("-").map(Number);
    if (!year || !month) return null;
    return new Date(year, month - 1, 1);
  }
  try {
    const parsed = new Date(periodValue);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  } catch {
    return null;
  }
}

// ✅ Same default logic as salary modal / backend service
const payrollDefaultConfig = {
  country: "KE",
  nssf: {
    lower_limit: 8000,
    upper_limit: 72000,
    rate: 0.06,
    employee_cap: 4320,
    employer_match: true,
  },
  shif: {
    rate: 0.0275,
    min: 300,
  },
  ahl: {
    rate: 0.015,
  },
  paye: {
    bands: [
      { up_to: 24000, rate: 0.1 },
      { up_to: 32333, rate: 0.25 },
      { up_to: 500000, rate: 0.3 },
      { up_to: 800000, rate: 0.325 },
    ],
    top_rate: 0.35,
    personal_relief: 2400,
    insurance_relief_rate: 0.15,
    insurance_relief_cap: 5000,
  },
};

const effectiveConfig = computed(() => {
  const cfg = payrollConfig.value || {};
  const nssf = cfg.nssf || {};
  const shif = cfg.shif || {};
  const ahl = cfg.ahl || {};
  const paye = cfg.paye || {};

  const bands =
    Array.isArray(paye.bands) && paye.bands.length
      ? paye.bands
      : payrollDefaultConfig.paye.bands;

  return {
    country: cfg.country || payrollDefaultConfig.country,
    nssf: {
      lower_limit: nssf.lower_limit ?? payrollDefaultConfig.nssf.lower_limit,
      upper_limit: nssf.upper_limit ?? payrollDefaultConfig.nssf.upper_limit,
      rate: nssf.rate ?? payrollDefaultConfig.nssf.rate,
      employee_cap: nssf.employee_cap ?? payrollDefaultConfig.nssf.employee_cap,
      employer_match:
        typeof nssf.employer_match === "boolean"
          ? nssf.employer_match
          : payrollDefaultConfig.nssf.employer_match,
    },
    shif: {
      rate: shif.rate ?? payrollDefaultConfig.shif.rate,
      min: shif.min ?? payrollDefaultConfig.shif.min,
    },
    ahl: {
      rate: ahl.rate ?? payrollDefaultConfig.ahl.rate,
    },
    paye: {
      personal_relief:
        paye.personal_relief ?? payrollDefaultConfig.paye.personal_relief,
      insurance_relief_rate:
        paye.insurance_relief_rate ??
        payrollDefaultConfig.paye.insurance_relief_rate,
      insurance_relief_cap:
        paye.insurance_relief_cap ??
        payrollDefaultConfig.paye.insurance_relief_cap,
      bands,
      top_rate: paye.top_rate ?? payrollDefaultConfig.paye.top_rate,
    },
    advance: {
      calculation_mode: cfg.advance?.calculation_mode || "fixed",
      default_percent_of_basic:
        cfg.advance?.default_percent_of_basic ?? 50,
    },
  };
});

const advanceRunHelpText = computed(() => {
  const mode = effectiveConfig.value.advance.calculation_mode;
  const pct = effectiveConfig.value.advance.default_percent_of_basic;
  const recoveryNote =
    " Full amount is recovered on this month’s Final payroll (not installments). Use Employee Loans for multi-month repayment.";

  if (mode === "fixed") {
    return (
      "Uses each employee's mid-month advance amount from their salary record. Statutory deductions are not applied." +
      recoveryNote
    );
  }
  if (mode === "hybrid") {
    return (
      `Uses the fixed amount when set on the employee salary record; otherwise ${pct}% of basic salary. Statutory deductions are not applied.` +
      recoveryNote
    );
  }
  return (
    `Pays ${pct}% of basic salary for each employee. Statutory deductions are not applied. Configure in Payroll Settings.` +
    recoveryNote
  );
});

function handleOutsideClick(e) {
  if (!e.target.closest(".dq-field")) {
    showEmployeeDropdown.value = false;
  }
}

// onMounted(() => {
//   document.addEventListener("click", handleOutsideClick);
// });

onBeforeUnmount(() => {
  document.removeEventListener("click", handleOutsideClick);
});

onMounted(async () => {
  const viewSalaryEl = document.getElementById("view-employee-salary");
  if (viewSalaryEl && viewSalaryEl.dataset.dqBackdropCleanup !== "1") {
    viewSalaryEl.dataset.dqBackdropCleanup = "1";
    viewSalaryEl.addEventListener("hidden.bs.modal", () => {
      clearBootstrapModalResidue();
    });
  }

  if (!companies.value.length) {
    await companyStore.fetchCompanies?.();
  }
  fetchSalaries();
  if (!designations.value.length) await designationStore.ensureDesignations();
  if (!employees.value.length) {
    await employeeStore.ensureEmployees({ status: "Active", per_page: 5000 });
  }

  // ✅ Load payroll config once
  if (!payrollConfig.value) {
    try {
      await payrollConfigStore.fetchConfig();
    } catch (e) {
      // If it fails, we gracefully fall back to defaults
      console.error("[Payroll] Failed to load config, using defaults.", e);
    }
  }

  if (dateRangeInput.value) {
    const start = moment().subtract(6, "days");
    const end = moment();
    new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      booking_range,
    );
    booking_range(start, end);
  }
  document.addEventListener("click", handleOutsideClick);
});

// --- HEADER COLLAPSE ---
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

const modalSalaryEmployee = ref(null);
const employeeSalaryModalRef = ref(null);
const toDeleteEmployee = ref(null);

// 👁 View salary state
const viewSalary = ref(null);

// Row click handler for a-table
const onRow = (record) => {
  return {
    onClick: (event) => {
      // Ignore clicks on action area or links/buttons
      if (
        event.target.closest(".action-icon") ||
        event.target.closest("a") ||
        event.target.closest("button")
      ) {
        return;
      }
      openViewSalary(record);
    },
  };
};

async function openViewSalary(row) {
  try {
    viewSalary.value = await fetchSalarySetupForModal(row);
    await nextTick();
    const el = document.getElementById("view-employee-salary");
    if (!el) return;
    Modal.getOrCreateInstance(el).show();
  } catch (err) {
    toast(
      err?.response?.data?.message || err?.message || "Failed to load salary details.",
      "error",
    );
  }
}

function closeViewSalary() {
  const el = document.getElementById("view-employee-salary");
  if (el) {
    const modal = Modal.getInstance(el) || Modal.getOrCreateInstance(el);
    el.addEventListener(
      "hidden.bs.modal",
      () => clearBootstrapModalResidue(),
      { once: true },
    );
    modal.hide();
  }
  viewSalary.value = null;
}

async function openAddModal() {
  modalSalaryEmployee.value = null;
  await nextTick();
  employeeSalaryModalRef.value?.showSalaryModal?.();
}

async function openEditModal(row) {
  try {
    const data = await fetchSalarySetupForModal(row);
    modalSalaryEmployee.value = data ? { ...data } : null;
    await nextTick();
    await nextTick();
    employeeSalaryModalRef.value?.showSalaryModal?.();
  } catch (err) {
    toast(
      err?.response?.data?.message || err?.message || "Failed to load salary for editing.",
      "error",
    );
  }
}

async function openDeleteModal(row) {
  toDeleteEmployee.value = row._raw;
  await nextTick();
  const el = document.getElementById("delete_modal");
  if (el) {
    Modal.getOrCreateInstance(el).show();
  }
}

// Computed payroll results

const payrollResults = computed(() => employeeSalaryStore.payrollResults || []);
const periodAdjustments = ref([]);
const periodAdjustmentsLoading = ref(false);
const payrollRun = computed(() => employeeSalaryStore.payrollRun || null);
const payrollApprovalStatus = computed(
  () => payrollRun.value?.approval_status || "pending_approval",
);
const payrollApprovalStatusLabel = computed(() =>
  payrollApprovalStatus.value === "approved" ? "Approved" : "Pending Approval",
);
const payrollApproverName = computed(() => {
  const approver = payrollRun.value?.approver;
  if (!approver) return "";
  return [approver.first_name, approver.last_name].filter(Boolean).join(" ");
});
const payrollCreatorName = computed(() => {
  const creator = payrollRun.value?.creator;
  if (!creator) return "";
  return [creator.first_name, creator.last_name].filter(Boolean).join(" ");
});
const payrollCreatorId = computed(() => Number(payrollRun.value?.created_by || 0));
const currentUserId = computed(() => Number(authUser.value?.id || 0));
const isPayrollMaker = computed(
  () => !!payrollCreatorId.value && payrollCreatorId.value === currentUserId.value,
);
const hasReviewablePayroll = computed(
  () => !!latestReviewablePayrollRun.value?.period,
);
const requireSeparateApprover = computed(
  () =>
    payrollConfig.value?.approval_workflow?.require_separate_approver !== false,
);
const showApprovalProgress = computed(
  () =>
    approvingPayroll.value &&
    employeeSalaryStore.loading &&
    payrollApprovalStatus.value !== "approved",
);
const canApprovePayroll = computed(
  () =>
    canApprovePayrollRole.value &&
    (!requireSeparateApprover.value || !isPayrollMaker.value) &&
    !!payrollResults.value.length &&
    payrollRun.value?.status === "completed" &&
    payrollApprovalStatus.value !== "approved" &&
    !employeeSalaryStore.loading,
);
const payrollRunIsPending = computed(
  () => payrollRun.value?.status === "pending",
);
function normalizeEmployeePaymentMode(row) {
  return String(row?.employee?.payment_mode || "").trim().toLowerCase();
}

const cashPaidEmployeeCount = computed(() =>
  payrollResults.value.filter(
    (row) => normalizeEmployeePaymentMode(row) === "cash",
  ).length,
);
function isChequePaymentMode(row) {
  const mode = normalizeEmployeePaymentMode(row);
  return mode === "check" || mode === "cheque";
}

const checkPaidEmployeeCount = computed(() =>
  payrollResults.value.filter((row) => isChequePaymentMode(row)).length,
);
const bankPaidEmployeeCount = computed(() =>
  payrollResults.value.filter(
    (row) => normalizeEmployeePaymentMode(row) === "bank transfer",
  ).length,
);
const showBankTransferShortcut = computed(
  () =>
    payrollApprovalStatus.value === "approved" &&
    payrollResults.value.length > 0 &&
    bankPaidEmployeeCount.value > 0,
);
const showCheckPayrollShortcut = computed(
  () =>
    payrollApprovalStatus.value === "approved" &&
    payrollResults.value.length > 0 &&
    checkPaidEmployeeCount.value > 0,
);
function operationalReportLocation(path) {
  const frequency =
    payFrequency.value || payrollRun.value?.frequency || "monthly";
  const query = { frequency };
  if (frequency === "monthly") {
    const ym =
      toYYYYMM(period.value) ||
      payrollRun.value?.period ||
      formattedPeriod.value ||
      currentPayrollYYYYMM();
    if (ym) {
      query.period = ym;
    }
  } else {
    const start = periodStart.value || payrollRun.value?.period_start;
    const end = periodEnd.value || payrollRun.value?.period_end;
    if (start) {
      query.period_start = start;
    }
    if (end) {
      query.period_end = end;
    }
  }
  return { path, query };
}

const bankTransferReportLocation = computed(() =>
  operationalReportLocation("/reports/bank-transfer-report"),
);
const checkPayrollReportLocation = computed(() =>
  operationalReportLocation("/reports/check-payroll-report"),
);
const cashPayrollReportLocation = computed(() =>
  operationalReportLocation("/reports/cash-payroll-report"),
);
const listPeriodBankTransferLink = computed(() => ({
  path: "/reports/bank-transfer-report",
  query: {
    frequency: "monthly",
    period: toYYYYMM(listPeriod.value) || currentPayrollYYYYMM(),
  },
}));
const periodWindowValidation = computed(() =>
  validateFrequencyWindow(payFrequency.value, periodStart.value, periodEnd.value),
);
const previewPeriodCode = computed(() =>
  payFrequency.value === "monthly"
    ? toYYYYMM(period.value) || ""
    : buildPeriodCodePreview(
        payFrequency.value,
        periodStart.value,
        periodEnd.value,
      ),
);

const monthlyPeriodSelectValue = computed(() => toYYYYMM(period.value) || "");

function monthlyGeneratePeriodLabel(ym) {
  const base = formatPayrollMonthLabel(ym) || ym;
  const rt = String(runType.value || "regular").toLowerCase();
  if (rt === "advance") {
    return `${base} (Advance)`;
  }
  if (rt === "final") {
    return `${base} (Final)`;
  }
  return base;
}

const selectableMonthlyPeriods = computed(() => {
  const catalog = Array.isArray(payrollPeriodCatalog.value)
    ? payrollPeriodCatalog.value
    : [];
  const closedSet = new Set(
    catalog.filter((row) => row.status === "closed").map((row) => row.period),
  );
  const labelFor = (ym, meta) =>
    meta?.period_label || formatPayrollMonthLabel(ym) || ym;

  if (payrollModalMode.value === "review") {
    return catalog
      .filter((row) => row.has_run)
      .map((row) => ({
        value: row.period,
        label:
          row.status === "closed"
            ? `${labelFor(row.period, row)} (Closed)`
            : labelFor(row.period, row),
        closed: row.status === "closed",
      }));
  }

  // Generate: calendar month label follows selected run type (not the latest run's label).
  const options = [];
  const now = new Date();
  for (let i = 0; i < 24; i += 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const ym = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    if (closedSet.has(ym)) continue;
    options.push({
      value: ym,
      label: monthlyGeneratePeriodLabel(ym),
      closed: false,
    });
  }
  return options;
});

async function refreshPayrollPeriodCatalog() {
  payrollPeriodCatalogLoading.value = true;
  try {
    const { data } = await payrollService.fetchPeriods();
    payrollPeriodCatalog.value = Array.isArray(data?.periods) ? data.periods : [];
  } catch (err) {
    console.error("[Payroll] failed to load period catalog:", err);
    payrollPeriodCatalog.value = [];
  } finally {
    payrollPeriodCatalogLoading.value = false;
  }
}

function onMonthlyPeriodSelectChange(event) {
  const ym = String(event?.target?.value || "").trim();
  if (!/^\d{4}-\d{2}$/.test(ym)) return;
  period.value = payrollPeriodToDate(ym);
  onPayrollPeriodPicked(period.value);
}

function isMonthlyPeriodClosed(ym) {
  if (!ym) return false;
  return (payrollPeriodCatalog.value || []).some(
    (row) => row.period === ym && row.status === "closed",
  );
}

function applySuggestedPeriodWindow(anchor = new Date()) {
  const suggestion = suggestPeriodWindow(payFrequency.value, anchor);
  if (payFrequency.value === "monthly") {
    period.value = suggestion.period
      ? payrollPeriodToDate(suggestion.period)
      : payrollPeriodToDate(currentPayrollYYYYMM());
    periodStart.value = "";
    periodEnd.value = "";
    return;
  }
  periodStart.value = suggestion.periodStart;
  periodEnd.value = suggestion.periodEnd;
}

function normalizePayrollPeriodDate(value) {
  if (!value || payFrequency.value !== "monthly") return;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return;
  const normalized = new Date(date.getFullYear(), date.getMonth(), 1);
  if (
    !period.value ||
    period.value.getFullYear() !== normalized.getFullYear() ||
    period.value.getMonth() !== normalized.getMonth() ||
    period.value.getDate() !== 1
  ) {
    period.value = normalized;
  }
}

async function onPayrollPeriodPicked(value) {
  normalizePayrollPeriodDate(value);
  if (payrollModalMode.value !== "review") return;
  await loadReviewPayrollForSelectedPeriod();
}

function resolvePayrollRunFetchParams() {
  const yyyyMm =
    currentPayrollPeriod.value ||
    toYYYYMM(period.value) ||
    payrollRun.value?.period ||
    "";

  const storedCode =
    payrollRun.value?.period_code ||
    latestReviewablePayrollRun.value?.period_code;

  if (storedCode) {
    return {
      period: payrollRun.value?.period || yyyyMm,
      period_code: storedCode,
    };
  }

  const runTypeKey =
    payrollRun.value?.run_type ||
    runType.value ||
    latestReviewablePayrollRun.value?.run_type ||
    "regular";

  if (payFrequency.value === "monthly" && yyyyMm) {
    return {
      period: yyyyMm,
      period_code: buildMonthlyPeriodCode(yyyyMm, runTypeKey),
      run_type: runTypeKey,
    };
  }

  return yyyyMm ? { period: yyyyMm } : {};
}

async function loadReviewPayrollForSelectedPeriod() {
  const yyyyMm = toYYYYMM(period.value);
  if (!yyyyMm) return;

  formError.value = "";
  employeeSalaryStore.error = null;
  employeeSalaryStore.payrollRun = null;
  employeeSalaryStore.payrollResults = [];

  try {
    await refreshPeriodStatus();
    const params = resolvePayrollRunFetchParams();
    if (!params.period && !params.period_code) return;

    try {
      await employeeSalaryStore.fetchPayrollRun(params, { force: true });
    } catch (err) {
      const altRuns = err?.response?.data?.runs;
      if (err?.response?.status === 409 && Array.isArray(altRuns) && altRuns.length) {
        const preferred =
          altRuns.find((row) => row.run_type === runType.value) || altRuns[0];
        if (preferred?.period_code) {
          runType.value = preferred.run_type || runType.value;
          await employeeSalaryStore.fetchPayrollRun(
            { period: yyyyMm, period_code: preferred.period_code },
            { force: true },
          );
        } else {
          throw err;
        }
      } else {
        throw err;
      }
    }

    if (payrollRun.value?.run_type) {
      runType.value = payrollRun.value.run_type;
    }
    if (!payrollRun.value) {
      formError.value = `No generated payroll run found for ${yyyyMm}.`;
    }
  } catch (err) {
    employeeSalaryStore.error = null;
    formError.value =
      err?.response?.data?.message ||
      `No generated payroll run found for ${yyyyMm}.`;
  }
}

function shiftPayrollWindow(direction = -1) {
  if (payFrequency.value === "monthly") return;
  const next = shiftPeriodWindow(
    payFrequency.value,
    periodStart.value,
    periodEnd.value,
    direction,
  );
  periodStart.value = next.periodStart;
  periodEnd.value = next.periodEnd;
}

const activeEmployees = computed(() =>
  employees.value.filter(
    (e) => String(e?.status || "").trim().toLowerCase() === "active",
  ),
);

const frequencyMatchedEmployees = computed(() =>
  activeEmployees.value.filter((employee) => {
    const employeeFrequency = String(employee?.pay_frequency || "monthly")
      .trim()
      .toLowerCase();
    return employeeFrequency === String(payFrequency.value || "monthly").toLowerCase();
  }),
);

const employeeOptions = computed(() =>
  activeEmployees.value.map((e) => ({
    id: Number(e.id), // enforce number
    text: `${e.first_name} ${e.last_name || ""} (${e.employee_id})`,
  })),
);

const frequencyMatchedEmployeeOptions = computed(() =>
  frequencyMatchedEmployees.value.map((e) => ({
    id: Number(e.id),
    text: `${e.first_name} ${e.last_name || ""} (${e.employee_id})`,
  })),
);

function handleEmployeeSelect() {
  if (selectedEmployeeIds.value.length > 0) {
    allEmployees.value = false;
  }
}

async function openGeneratePayrollModal() {
  payrollModalMode.value = "generate";
  // Optionally fetch employees
  if (!employees.value.length) {
    employeeStore.fetchEmployees({ status: "Active", per_page: 5000 });
  }
  refreshLatestReviewablePayrollRun();
  await refreshPayrollPeriodCatalog();
  payFrequency.value = "monthly";
  selectedEmployeeIds.value = [];
  allEmployees.value = true;
  employeeSalaryStore.payrollResults = [];
  employeeSalaryStore.payrollRun = null;
  employeeSalaryStore.error = null;

  forceRun.value = true; // always recompute
  emailPayslips.value = true; // but emails will only actually send on first run
  approvalNotes.value = "";
  applySuggestedPeriodWindow();

  // If suggested month is closed, jump to the first selectable open month.
  const ym = toYYYYMM(period.value);
  if (ym && isMonthlyPeriodClosed(ym)) {
    const firstOpen = selectableMonthlyPeriods.value[0]?.value;
    if (firstOpen) {
      period.value = payrollPeriodToDate(firstOpen);
    }
  }
}

async function refreshLatestReviewablePayrollRun() {
  try {
    const { data } = await payrollService.fetchLatestRun();
    latestReviewablePayrollRun.value = data?.run || null;
  } catch (err) {
    if (err?.response?.status === 404) {
      latestReviewablePayrollRun.value = null;
      return;
    }
    console.error("[Payroll] failed to fetch latest reviewable run:", err);
  }
}

watch(
  () => activeCompanyId.value,
  async (companyId) => {
    if (!companyId) {
      latestReviewablePayrollRun.value = null;
      return;
    }
    await refreshLatestReviewablePayrollRun();
  },
  { immediate: true },
);

watch(
  () => payrollApprovalStatus.value,
  (status) => {
    if (status === "approved") {
      approvingPayroll.value = false;
    }
  },
);

async function openReviewPayrollModal() {
  if (!latestReviewablePayrollRun.value?.period) return;

  payrollModalMode.value = "review";
  if (!employees.value.length) {
    employeeStore.fetchEmployees({ status: "Active", per_page: 5000 });
  }

  formError.value = "";
  payrollRunTriggered.value = true;
  employeeSalaryStore.error = null;
  selectedEmployeeIds.value = [];
  allEmployees.value = true;
  forceRun.value = false;
  approvalNotes.value = "";
  await refreshPayrollPeriodCatalog();
  period.value = payrollPeriodToDate(latestReviewablePayrollRun.value.period);
  payFrequency.value = latestReviewablePayrollRun.value.frequency || "monthly";
  runType.value = latestReviewablePayrollRun.value.run_type || "regular";
  periodStart.value = latestReviewablePayrollRun.value.period_start || "";
  periodEnd.value = latestReviewablePayrollRun.value.period_end || "";
  emailPayslips.value =
    latestReviewablePayrollRun.value.email_payslips_on_approval ?? true;

  try {
    await employeeSalaryStore.fetchPayrollRun(
      {
        period: latestReviewablePayrollRun.value.period,
        period_code: latestReviewablePayrollRun.value.period_code,
      },
      { force: true },
    );
    await refreshPeriodStatus();
  } catch (err) {
    console.error("[Payroll] failed to load payroll run for review:", err);
  }
}

// function toggleAllEmployees() {
//   if (allEmployees.value) selectedEmployeeIds.value = [];
// }

function money(val) {
  return (
    companyCurrencySymbol.value +
    " " +
    Number(val ?? 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}

function capitalize(value) {
  const str = String(value || "").trim();
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const runTypeLabel = computed(() => {
  const source =
    payrollRun.value?.run_type ||
    latestReviewablePayrollRun.value?.run_type ||
    runType.value;
  return getPayrollRunTypeLabel(source) || capitalize(source);
});

const payrollRunTypeOptions = PAYROLL_RUN_TYPE_OPTIONS;

const canSelectFinalRun = computed(
  () => !!periodStatus.value?.advance_run,
);

const formattedPeriod = computed(() => toYYYYMM(period.value));
const currentPayrollPeriod = computed(() => {
  // In review mode, follow the picker so August/September can be switched.
  if (payrollModalMode.value === "review") {
    return formattedPeriod.value || payrollRun.value?.period || "";
  }
  return payFrequency.value === "monthly"
    ? formattedPeriod.value
    : (periodStart.value || "").slice(0, 7);
});
const currentPayrollPeriodCode = computed(() => {
  if (payrollModalMode.value === "review" && payrollRun.value?.period_code) {
    return payrollRun.value.period_code;
  }
  const periodCode = previewPeriodCode.value;
  if (!periodCode) return "";
  if (payFrequency.value !== "monthly") return periodCode;
  if (runType.value === "final") return `${periodCode}:final`;
  return periodCode;
});
const periodAdjustmentSummary = computed(() =>
  periodAdjustments.value.reduce(
    (summary, entry) => {
      summary.count += 1;
      if (entry.direction === "addition") summary.additions += Number(entry.amount || 0);
      else summary.deductions += Number(entry.amount || 0);
      return summary;
    },
    { count: 0, additions: 0, deductions: 0 },
  ),
);

async function refreshPeriodAdjustments() {
  const periodCode = currentPayrollPeriodCode.value;
  if (!periodCode) {
    periodAdjustments.value = [];
    return;
  }
  periodAdjustmentsLoading.value = true;
  try {
    const { data } = await payrollComponentEntryService.list({
      period_code: periodCode,
      frequency: payFrequency.value,
      period_start: periodStart.value || undefined,
      period_end: periodEnd.value || undefined,
      status: "active",
      per_page: 200,
    });
    periodAdjustments.value = data?.data || [];
  } catch (error) {
    console.error("[Payroll] period adjustments failed:", error);
    periodAdjustments.value = [];
  } finally {
    periodAdjustmentsLoading.value = false;
  }
}
const showClosePeriodAction = computed(
  () =>
    payFrequency.value === "monthly" &&
    !!periodStatus.value?.can_close &&
    canApprovePayrollRole.value &&
    periodStatus.value?.status !== "closed",
);

async function refreshPeriodStatus() {
  const yyyyMm = currentPayrollPeriod.value;
  if (payFrequency.value !== "monthly" || !yyyyMm || !/^\d{4}-\d{2}$/.test(yyyyMm)) {
    periodStatus.value = null;
    return;
  }

  periodStatusLoading.value = true;
  try {
    const { data } = await payrollService.fetchPeriodStatus(yyyyMm);
    periodStatus.value = data;
  } catch (err) {
    console.error("[Payroll] period status failed:", err);
    periodStatus.value = null;
  } finally {
    periodStatusLoading.value = false;
  }
}

function handleClosePeriod() {
  const yyyyMm = currentPayrollPeriod.value;
  if (!yyyyMm || !canApprovePayrollRole.value) return;
  closePeriodConfirmRef.value?.open(yyyyMm);
}

async function onClosePeriodConfirmed({ period: yyyyMm }) {
  const modal = closePeriodConfirmRef.value;
  modal?.setSubmitting(true);
  closingPeriod.value = true;
  try {
    const { data } = await payrollService.closePeriod(yyyyMm);
    periodStatus.value = data?.period || periodStatus.value;
    toast(data?.message || "Payroll period closed.", "success");
    modal?.hide();
    await refreshLatestReviewablePayrollRun();
    await refreshPayrollPeriodCatalog();
  } catch (err) {
    toast(err?.response?.data?.message || "Failed to close payroll period.", "error");
  } finally {
    closingPeriod.value = false;
    modal?.setSubmitting(false);
  }
}

watch(payFrequency, () => {
  const allowedIds = new Set(frequencyMatchedEmployeeOptions.value.map((emp) => emp.id));
  selectedEmployeeIds.value = selectedEmployeeIds.value.filter((id) =>
    allowedIds.has(Number(id)),
  );
  if (payrollModalMode.value !== "review") {
    applySuggestedPeriodWindow();
  }
});

watch(periodStart, (start) => {
  if (payrollModalMode.value === "review" || payFrequency.value === "monthly" || !start) {
    return;
  }
  if (payFrequency.value === "daily") {
    periodEnd.value = start;
    return;
  }
  periodEnd.value = endDateForFrequency(payFrequency.value, start);
});

watch(
  [currentPayrollPeriod, payFrequency, payrollModalMode],
  () => {
    if (payFrequency.value === "monthly") {
      refreshPeriodStatus();
    } else {
      periodStatus.value = null;
    }
  },
  { immediate: true },
);

watch(currentPayrollPeriodCode, refreshPeriodAdjustments, { immediate: true });

watch(payFrequency, (freq) => {
  if (freq !== "monthly") {
    runType.value = "regular";
  }
});

watch(
  () => periodStatus.value?.advance_run,
  (advanceRun) => {
    if (payrollModalMode.value === "review") return;
    if (runType.value === "final" && !advanceRun) {
      runType.value = "regular";
    }
  },
);
const currentPayrollRunSelector = computed(() => resolvePayrollRunFetchParams());
const currentPayrollPeriodLabel = computed(() =>
  payrollModalMode.value === "review"
    ? formatPayrollMonthLabel(currentPayrollPeriod.value) ||
      payrollRun.value?.period_label ||
      latestReviewablePayrollRun.value?.period_label
    : payFrequency.value === "monthly"
      ? formatPayrollMonthLabel(currentPayrollPeriod.value)
      : [periodStart.value, periodEnd.value].filter(Boolean).join(" to "),
);

async function handleGeneratePayroll() {
  formError.value = "";
  payrollRunTriggered.value = false;

  if (payFrequency.value === "monthly" && !period.value) {
    formError.value = "Payroll period is required!";
    return;
  }
  if (
    payFrequency.value === "monthly" &&
    isMonthlyPeriodClosed(toYYYYMM(period.value))
  ) {
    formError.value =
      "Payroll for this month is closed and cannot be generated again.";
    return;
  }
  if (payFrequency.value !== "monthly" && (!periodStart.value || !periodEnd.value)) {
    formError.value = "Start and end date are required for the selected payroll frequency.";
    return;
  }
  if (!allEmployees.value && selectedEmployeeIds.value.length === 0) {
    formError.value =
      "Please select at least one employee or check 'All Employees'.";
    return;
  }

  if (!["monthly", "weekly", "fortnightly", "daily"].includes(payFrequency.value)) {
    formError.value =
      "Unsupported payroll frequency selected.";
    return;
  }

  const windowCheck = validateFrequencyWindow(
    payFrequency.value,
    periodStart.value,
    periodEnd.value,
  );
  if (!windowCheck.ok) {
    formError.value = windowCheck.message;
    return;
  }

  if (shouldWarnAdvanceRegularRun()) {
    advanceRegularRunConfirmRef.value?.open({
      periodLabel: formattedPeriod.value || currentPayrollPeriod.value,
    });
    return;
  }

  await executeGeneratePayrollRun();
}

function shouldWarnAdvanceRegularRun() {
  return (
    payFrequency.value === "monthly" &&
    runType.value === "regular" &&
    !!periodStatus.value?.advance_run
  );
}

function onAdvanceRunSwitchToFinal() {
  runType.value = "final";
  toast("Run type set to Month-End Final Payroll. Click Run Payroll when ready.", "info");
}

async function onAdvanceRegularRunConfirmed() {
  await executeGeneratePayrollRun();
}

async function executeGeneratePayrollRun() {
  startPayrollProgress();

  const yyyyMm =
    payFrequency.value === "monthly"
      ? toYYYYMM(period.value)
      : String(periodStart.value || "").slice(0, 7);

  const employeeIds = allEmployees.value
    ? []
    : (Array.isArray(selectedEmployeeIds.value)
        ? selectedEmployeeIds.value
        : [selectedEmployeeIds.value]
      )
        .map((e) => (typeof e === "object" && e !== null ? e.id : e))
        .filter((v) => v != null)
        .map((v) => Number(v));

  const payload = {
    period: yyyyMm,
    frequency: payFrequency.value,
    run_type: payFrequency.value === "monthly" ? runType.value : "regular",
    period_start:
      payFrequency.value === "monthly"
        ? undefined
        : periodStart.value || undefined,
    period_end:
      payFrequency.value === "monthly" ? undefined : periodEnd.value || undefined,
    employee_ids: employeeIds,
    email_payslips: emailPayslips.value,
    force: forceRun.value,
  };

  console.log("[Payroll] request payload:", payload);

  try {
    await employeeSalaryStore.runPayroll(payload);

    const pollPayload = {
      period: yyyyMm,
      frequency: payFrequency.value,
      run_type: payFrequency.value === "monthly" ? runType.value : "regular",
      period_start:
        payFrequency.value === "monthly" ? undefined : periodStart.value || undefined,
      period_end:
        payFrequency.value === "monthly" ? undefined : periodEnd.value || undefined,
      employee_ids: employeeIds,
      force: false,
      email_payslips: false,
    };

    forceRun.value = false;

    const start = Date.now();
    const POLL_MS = 1500;
    const MAX_MS = 20000;

    const poll = setInterval(async () => {
      try {
        await employeeSalaryStore.runPayroll(pollPayload);
        const results = employeeSalaryStore.payrollResults || [];
        const done =
          (employeeSalaryStore.payrollRun?.status === "completed" &&
            results.length >= 0) ||
          false;
        if (done) {
          clearInterval(poll);
          finishPayrollProgress();
        }
        if (Date.now() - start > MAX_MS) {
          clearInterval(poll);
          finishPayrollProgress();
        }
      } catch (e) {
        console.error("[Payroll] poll failed:", e);
        clearInterval(poll);
        stopPayrollProgress();
      }
    }, POLL_MS);

    payrollRunTriggered.value = true;
    await refreshLatestReviewablePayrollRun();
    await refreshPeriodStatus();
    if ((employeeSalaryStore.payrollResults || []).length) {
      toast("Payroll generated. Review and approve to finalize payslips.", "success");
    }
  } catch (err) {
    stopPayrollProgress();
    payrollRunConflict.value = err?.response?.status === 409;
    console.error("[Payroll] run failed:", err);
  }
}

async function forceRecalculatePayroll() {
  payrollRunConflict.value = false;
  employeeSalaryStore.error = null;
  forceRun.value = true;
  await handleGeneratePayroll();
}

async function approveCurrentPayroll() {
  if (!canApprovePayroll.value || !currentPayrollPeriod.value) return;

  try {
    approvingPayroll.value = true;
    const approveParams = {
      ...currentPayrollRunSelector.value,
      approval_notes: approvalNotes.value || null,
    };
    await employeeSalaryStore.approvePayroll(approveParams);

    const approvedCode = employeeSalaryStore.payrollRun?.period_code;
    const approvedPeriod =
      employeeSalaryStore.payrollRun?.period || approveParams.period;
    if (approvedCode) {
      await employeeSalaryStore.fetchPayrollRun(
        { period: approvedPeriod, period_code: approvedCode },
        { force: true },
      );
    } else if (approveParams.period_code) {
      await employeeSalaryStore.fetchPayrollRun(
        {
          period: approveParams.period,
          period_code: approveParams.period_code,
        },
        { force: true },
      );
    }
    await fetchSalaries();
    await refreshLatestReviewablePayrollRun();
    await refreshPeriodStatus();
  } catch (err) {
    console.error("[Payroll] approval failed:", err);
  } finally {
    approvingPayroll.value = false;
  }
}

function resetModal() {
  stopPayrollProgress();
  payrollProgress.value = 0;
  payrollModalMode.value = "generate";
  payFrequency.value = "monthly";
  runType.value = "regular";
  period.value = null;
  periodStart.value = "";
  periodEnd.value = "";
  periodStatus.value = null;
  selectedEmployeeIds.value = [];
  allEmployees.value = true;
  formError.value = "";
  payrollRunTriggered.value = false;
  employeeSalaryStore.payrollResults = [];
  employeeSalaryStore.payrollRun = null;
  employeeSalaryStore.error = null;
  payrollRunConflict.value = false;
  retryingEmployees.value = {};
  emailPayslips.value = true;
  forceRun.value = false;
  approvalNotes.value = "";
  approvingPayroll.value = false;
}

function payrollResultEmployeeName(row) {
  const emp = row?.employee || {};
  const fromParts = [emp.first_name, emp.middle_name, emp.last_name]
    .filter(Boolean)
    .join(" ")
    .trim();
  return (
    emp.full_name ||
    fromParts ||
    row?.employee_name ||
    emp.employee_id ||
    row?.employee_id ||
    "—"
  );
}

function csvEscape(value) {
  const text = value == null ? "" : String(value);
  if (/[",\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

function exportPayrollCSV() {
  const exportPeriod =
    currentPayrollRunSelector.value?.period_code ||
    currentPayrollPeriod.value ||
    formattedPeriod.value;
  const rows = [
    [
      "Employee Name",
      "Employee ID",
      "Gross",
      "NSSF",
      "SHA",
      "AHL",
      "PAYE",
      "HELB",
      "Total Deductions",
      "Net Pay",
    ],
    ...payrollResults.value.map((row) => [
      payrollResultEmployeeName(row),
      row.employee?.employee_id || row.employee_id || "",
      row.breakdown.gross_salary,
      row.breakdown.nssf,
      row.breakdown.shif,
      row.breakdown.ahl,
      row.breakdown.paye,
      row.breakdown.helb,
      row.breakdown.total_deductions,
      row.breakdown.net_pay,
    ]),
  ];
  const yyyymm = exportPeriod;
  const csvContent =
    "data:text/csv;charset=utf-8," +
    rows.map((cols) => cols.map(csvEscape).join(",")).join("\n");
  const link = document.createElement("a");
  link.setAttribute("href", csvContent);
  link.setAttribute("download", `payroll-${yyyymm}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

async function downloadAllPayslips() {
  try {
    const runSelector = currentPayrollRunSelector.value || {};
    const yyyyMm = runSelector.period || currentPayrollPeriod.value || formattedPeriod.value;

    if (!yyyyMm) {
      toast(
        "Payroll period is missing. Please select a period first.",
        "error",
      );
      return;
    }

    if (!payrollResults.value.length) {
      toast("No payroll results to download.", "error");
      return;
    }

    // Collect unique employee IDs from the results
    const employeeIds = payrollResults.value
      .map((row) => row.employee?.id ?? row.employee_id)
      .filter((id) => id != null);

    const uniqueEmployeeIds = [...new Set(employeeIds)];

    if (!uniqueEmployeeIds.length) {
      toast("Could not determine employee IDs for this run.", "error");
      return;
    }

    const res = await payrollService.bulkDownload({
      period: yyyyMm,
      period_code: runSelector.period_code,
      employee_ids: uniqueEmployeeIds,
    });

    const blob = new Blob([res.data], { type: "application/zip" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `payslips-${yyyyMm}.zip`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (e) {
    console.error("[Payroll] bulk download failed:", e);
    toast("Failed to download all payslips.", "error");
  }
}

// Payslip-related actions (assumes services/endpoints exist)
function formatDate(dt) {
  return new Date(dt).toLocaleDateString(); // fix: was toLocaleDgateString()
}

async function downloadPayslipById(payslipId) {
  try {
    const res = await payrollService.download(payslipId);
    const url = URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = `payslip-${payslipId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (e) {
    toast("Failed to download payslip.", "error");
  }
}

async function resendPayslipEmail(payslipId) {
  try {
    await payrollService.resendPayslipEmail(payslipId); // you need to implement this in payroll.service
    toast("Payslip email requeued.", "success");
  } catch (e) {
    toast("Failed to resend payslip email.", "error");
  }
}

function retryEmployee(employeeId) {
  retryEmployeePayroll(employeeId);
}

async function retryEmployeePayroll(employeeId) {
  if (!employeeId || retryingEmployees.value[employeeId]) return;

  const payrollMonth =
    currentPayrollPeriod.value ||
    formattedPeriod.value ||
    currentPayrollYYYYMM();
  const runSelector = currentPayrollRunSelector.value || {};

  retryingEmployees.value = {
    ...retryingEmployees.value,
    [employeeId]: true,
  };

  try {
    await employeeSalaryStore.runPayroll({
      period: payrollMonth,
      period_code: runSelector.period_code,
      frequency: payFrequency.value,
      period_start:
        payFrequency.value === "monthly"
          ? undefined
          : periodStart.value || undefined,
      period_end:
        payFrequency.value === "monthly"
          ? undefined
          : periodEnd.value || undefined,
      employee_ids: [Number(employeeId)],
      email_payslips: false,
      force: true,
    });
    toast("Employee payroll recalculated.", "success");
  } catch (e) {
    // store surfaces API message
  } finally {
    const next = { ...retryingEmployees.value };
    delete next[employeeId];
    retryingEmployees.value = next;
  }
}

// async function generateSlipFor(row) {
//   const employeeId = row?.employee?.id ?? row?.employee_id ?? row?.id;

//   // Prefer the salary's own payroll_month if present, else fallback
//   const payrollMonth = row?.payroll_month
//     ? toYYYYMM(row.payroll_month)
//     : formattedPeriod.value || new Date().toISOString().slice(0, 7);

//   try {
//     const { data } = await payrollService.generateSingle({
//       period: payrollMonth,
//       employee_id: employeeId,
//       email: false,
//       force: true,
//     });

//     toast("Payslip generation triggered", "success");

//     // Refresh that employee's payroll result (no re-run)
//     await employeeSalaryStore.runPayroll({
//       period: payrollMonth,
//       employee_ids: [employeeId],
//       email_payslips: false,
//       force: false,
//     });

//     if (data?.payslip?.id) {
//       await downloadPayslipById(data.payslip.id);
//     }
//   } catch (e) {
//     toast(
//       "Failed to generate slip: " + (e.response?.data?.message || e.message),
//       "error"
//     );
//   }
// }

async function generateSlipFor(row) {
  const employeeId = row?.employee?.id ?? row?.employee_id ?? row?.id;
  if (!employeeId) return;

  // prevent double-clicks
  if (payslipGenerating.value[employeeId]) return;

  // mark as generating
  payslipGenerating.value = {
    ...payslipGenerating.value,
    [employeeId]: true,
  };

  // prefer row.payroll_month if present
  const payrollMonth =
    row?.payroll_run_period ||
    (row?.payroll_month
      ? toYYYYMM(row.payroll_month)
      : currentPayrollPeriod.value ||
        formattedPeriod.value ||
        currentPayrollYYYYMM());
  const periodCode = currentPayrollRunSelector.value?.period_code;

  try {
    const { data } = await payrollService.generateSingle({
      period: payrollMonth,
      period_code: periodCode,
      employee_id: employeeId,
      email: false,
      force: true,
    });

    toast("Payslip generation triggered", "success");

    // refresh that employee's payroll result (no re-run)
    await employeeSalaryStore.fetchPayrollRun(
      periodCode ? { period: payrollMonth, period_code: periodCode } : payrollMonth,
      { force: true },
    );

    if (data?.payslip?.id) {
      await downloadPayslipById(data.payslip.id);
    }
  } catch (e) {
    toast(
      "Failed to generate slip: " + (e.response?.data?.message || e.message),
      "error",
    );
  } finally {
    // clear flag
    const copy = { ...payslipGenerating.value };
    delete copy[employeeId];
    payslipGenerating.value = copy;
  }
}

async function handlePayslipAction(row) {
  const canGenerate =
    row?.canGenerateSlip ??
    (row?.payroll_run_status === "completed" &&
      row?.payroll_approval_status === "approved" &&
      !!row?.payroll_result?.id);

  if (!canGenerate) return;

  const payslipId = row?.payroll_result?.payslip?.id;
  if (payslipId) {
    await downloadPayslipById(payslipId);
    return;
  }

  await generateSlipFor(row);
}

async function downloadPayslipForViewSalary() {
  if (!viewSalary.value || !canUseViewSalaryPayslipAction.value) return;

  const payslipId = viewSalary.value?.payroll_result?.payslip?.id;
  if (payslipId) {
    await downloadPayslipById(payslipId);
    return;
  }

  await generateSlipFor(viewSalary.value);
}
</script>

<style scoped>
.net-pay {
  font-weight: bold;
  color: #28a745;
  font-size: 1.1em !important;
}

/* ===== DoneQuick Premium Modals ===== */
.dq-modal .dq-modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
  background: #fff;
}

/* Header */
.dq-modal-header {
  padding: 18px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #0f172a 0%, #111827 55%, #0b1220 100%);
  color: #fff;
}

.dq-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.dq-modal-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
}

.dq-modal-icon-success {
  background: rgba(34, 197, 94, 0.18);
}

.dq-title {
  margin: 0;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.dq-subtitle {
  font-size: 12.5px;
  color: white;
  margin-top: 2px;
}

.dq-dot {
  margin: 0 8px;
  opacity: 0.6;
}

.dq-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dq-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
}

.dq-close {
  width: 40px;
  height: 40px;
  border-radius: 12px;
}

/* Body scroll fix */
.dq-modal-body {
  padding: 18px;
}

.dq-scroll {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

/* Footer sticky */
.dq-modal-footer {
  padding: 14px 18px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: #fff;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
  position: sticky;
  bottom: 0;
  z-index: 5;
}

.dq-btn {
  border-radius: 12px !important;
  padding: 10px 14px;
}

/* Cards */
.dq-card {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  padding: 16px;
  background: #fff;
}

.dq-card-gradient {
  background: radial-gradient(
      1200px 350px at 0% 0%,
      rgba(59, 130, 246, 0.16),
      transparent 45%
    ),
    radial-gradient(
      1200px 350px at 100% 0%,
      rgba(34, 197, 94, 0.12),
      transparent 45%
    ),
    #0b1220;
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
}

.dq-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.dq-card-title {
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.dq-badge-soft {
  background: rgba(15, 23, 42, 0.06) !important;
  color: #0f172a !important;
  border: 1px solid rgba(15, 23, 42, 0.08);
}

/* Employee card */
.dq-employee {
  display: flex;
  gap: 12px;
  align-items: center;
}

.dq-avatar {
  width: 54px;
  height: 54px;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.dq-avatar :deep(.dq-avatar-shell) {
  width: 100%;
  height: 100%;
}

.dq-emp-name {
  font-weight: 800;
  font-size: 15px;
}

.dq-emp-sub {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dq-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

/* Metrics */
.dq-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.14);
  margin: 14px 0;
}

.dq-metric-label {
  font-size: 12px;
  opacity: 0.8;
}

.dq-metric-value {
  font-size: 22px;
  font-weight: 900;
  margin-top: 2px;
}

.dq-metric-hint {
  font-size: 12px;
  opacity: 0.75;
  margin-top: 4px;
}

.dq-mini-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

@media (min-width: 992px) {
  .dq-mini-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.dq-mini {
  padding: 12px;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(15, 23, 42, 0.02);
}

.dq-mini-label {
  font-size: 12px;
  color: rgba(15, 23, 42, 0.7);
}

.dq-mini-value {
  font-weight: 800;
  margin-top: 4px;
}

.dq-muted {
  color: rgba(15, 23, 42, 0.6);
}

/* Breakdown table blocks */
.dq-section-title {
  font-weight: 800;
  font-size: 13px;
  color: rgba(15, 23, 42, 0.75);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.dq-table {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 14px;
  overflow: hidden;
}

.dq-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.dq-row:last-child {
  border-bottom: 0;
}

.dq-k {
  color: rgba(15, 23, 42, 0.75);
  font-weight: 600;
}

.dq-v {
  font-weight: 800;
}

.dq-total {
  background: rgba(34, 197, 94, 0.08);
}

.dq-note {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(59, 130, 246, 0.18);
  background: rgba(59, 130, 246, 0.06);
  color: rgba(15, 23, 42, 0.8);
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Payroll progress */
.dq-progress-wrap {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  padding: 14px;
  background: rgba(15, 23, 42, 0.02);
}

.dq-progress-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.dq-progress-title {
  font-weight: 800;
  color: rgba(15, 23, 42, 0.85);
}

.dq-progress-pct {
  font-weight: 900;
}

.dq-progress {
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
}

.dq-progress-steps {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dq-step {
  font-size: 12px;
  padding: 8px 10px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  color: rgba(15, 23, 42, 0.55);
  background: #fff;
  display: inline-flex;
  gap: 8px;
  align-items: center;
}

.dq-step.active {
  color: rgba(15, 23, 42, 0.9);
  border-color: rgba(34, 197, 94, 0.25);
  background: rgba(34, 197, 94, 0.08);
}

.dq-field .dq-label {
  font-weight: 800;
  font-size: 13px;
  color: rgba(15, 23, 42, 0.75);
}

.dq-field .dq-help {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(15, 23, 42, 0.55);
}

.dq-icon-btn {
  border-radius: 12px;
  width: 38px;
  height: 34px;
  display: inline-grid;
  place-items: center;
}

.dq-table-wrap {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  overflow: auto;
  max-height: 62vh;
}

.dq-payroll-results {
  border-collapse: separate;
  border-spacing: 0;
}

.dq-payroll-results th,
.dq-payroll-results td {
  white-space: nowrap;
  vertical-align: top;
}

.dq-payroll-results thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8fafc;
}

.dq-payroll-employee {
  width: 240px;
  min-width: 220px;
  max-width: 260px;
  white-space: normal !important;
  position: sticky;
  left: 0;
  z-index: 1;
  background: #fff;
  box-shadow: 8px 0 12px -12px rgba(15, 23, 42, 0.45);
}

.dq-payroll-results thead .dq-payroll-employee {
  z-index: 3;
  background: #f8fafc;
}

.dq-payroll-results tbody tr:hover .dq-payroll-employee {
  background: #f8fafc;
}

.dq-payroll-name {
  line-height: 1.3;
}

.dq-payroll-notes {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}

.dq-payroll-note {
  display: inline-block;
  max-width: 100%;
  padding: 2px 6px;
  border-radius: 6px;
  background: rgba(15, 23, 42, 0.06);
  color: rgba(15, 23, 42, 0.72);
  font-size: 11px;
  line-height: 1.35;
  white-space: normal;
}

.dq-payroll-payslip {
  min-width: 108px;
  white-space: normal !important;
}

/* Empty */
.dq-empty {
  min-height: 220px;
  display: grid;
  place-items: center;
  color: rgba(15, 23, 42, 0.55);
  font-weight: 600;
  text-align: center;
}

/* ===== Employee Dropdown ===== */
.dq-employee-btn {
  border-radius: 12px;
  padding: 10px 12px;
}

.dq-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 1056; /* above modal body */
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  padding: 10px;
}

.dq-dropdown-list {
  max-height: 220px;
  overflow-y: auto;
}

.dq-dropdown-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
}

.dq-dropdown-item:hover {
  background: rgba(15, 23, 42, 0.05);
}

/* Selected pills */
.dq-selected-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.dq-selected-pills .dq-pill {
  background: rgba(59, 130, 246, 0.1);
  color: #1d4ed8;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: default;
}

.dq-selected-pills .ti-x {
  cursor: pointer;
  font-size: 12px;
}

.dq-modal-dialog-tall {
  max-width: 1200px; /* wider than default modal-xl */
}

@media (min-width: 1400px) {
  .dq-modal-dialog-tall {
    max-width: 1320px; /* very nice on large screens */
  }
}

/* Make body taller and scroll nicely */
.dq-scroll {
  max-height: calc(100vh - 170px); /* taller modal body */
  overflow: auto;
}
</style>


